import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Map: unknown;
  Time: string;
  TimeStamp: string;
};

export type Acceptance = {
  readonly __typename?: 'Acceptance';
  readonly ageRestriction: AgeRestriction;
  readonly class: Scalars['String'];
  readonly date: Scalars['TimeStamp'];
  readonly distance: Scalars['Int'];
  readonly gbsMeetingId: Scalars['String'];
  readonly jockey: Scalars['String'];
  readonly jockeyGlobalId: Scalars['ID'];
  readonly prizeTotal: Scalars['Int'];
  readonly raceName: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
  readonly runner: Scalars['String'];
  readonly runnerGlobalId: Scalars['ID'];
  readonly sexRestriction: SexRestriction;
  readonly startTime: Scalars['TimeStamp'];
  readonly track: Scalars['String'];
  readonly trainer: Scalars['String'];
  readonly trainerGlobalId: Scalars['ID'];
};

/** Represents an active (non-scratched) runner in the market at the time a Rule 4 deduction was calculated. */
export type ActiveRunnerRule4 = {
  readonly __typename?: 'ActiveRunnerRule4';
  /** The name of the active runner. */
  readonly Name: Scalars['String'];
  /** The number of the active runner. */
  readonly Number: Scalars['Int'];
  /** The price of the active runner. */
  readonly Price: Scalars['Float'];
};

/** Defines the age range of competitors eligible for a race. */
export type AgeRestriction = {
  readonly __typename?: 'AgeRestriction';
  /** The maximum age of a competitor to be eligible. */
  readonly maximumAgeInclusive: Scalars['Int'];
  /** The minimum age of a competitor to be eligible. */
  readonly minimumAgeInclusive: Scalars['Int'];
};

/** Represents a single price point and the available volume on one side of a Betfair market (either to back or to lay). */
export type BetFairLevel = {
  readonly __typename?: 'BetFairLevel';
  /** The position in the price ladder (e.g., 1 for the best available price, 2 for the second best, etc.). */
  readonly level: Scalars['Int'];
  /** The decimal odds offered at this level. */
  readonly price: Scalars['Float'];
  /** The amount of money available to be matched at this price. */
  readonly volume: Scalars['Float'];
};

/** Represents an entire Betfair exchange market for a specific race outcome, such as the Win or Place market. */
export type BetFairMarket = {
  readonly __typename?: 'BetFairMarket';
  /** Betfair's unique identifier for this market. */
  readonly id: Scalars['String'];
  /** Indicates if the market is closed for betting. */
  readonly isClosed: Scalars['Boolean'];
  /** The unique internal identifier for the meeting this market belongs to. */
  readonly meetingId: Scalars['ID'];
  /** The type of market (e.g., WIN, PLACE). */
  readonly priceType: BetFairPriceType;
  /** The number of the race this market is for. */
  readonly raceNumber: Scalars['Int'];
  /** A list of all the competitors (selections) available in this market. */
  readonly selections?: Maybe<ReadonlyArray<BetFairSelection>>;
  /** The total amount of money that has been matched across all selections in this market. */
  readonly totalTraded?: Maybe<Scalars['Float']>;
};

export enum BetFairPriceType {
  Place = 'PLACE',
  Win = 'WIN'
}

/** Represents a single competitor (a "selection") and its associated data within a Betfair exchange market. */
export type BetFairSelection = {
  readonly __typename?: 'BetFairSelection';
  /** A list of the best available prices and volumes to BACK this selection (bet that it will win). */
  readonly availableToBack?: Maybe<ReadonlyArray<BetFairLevel>>;
  /** A list of the best available prices and volumes to LAY this selection (bet that it will lose). */
  readonly availableToLay?: Maybe<ReadonlyArray<BetFairLevel>>;
  /** For markets where multiple runners are coupled as a single betting interest, this is the coupling code. */
  readonly couplingCode?: Maybe<Scalars['String']>;
  /** Indicates if the competitor has been scratched from the race. */
  readonly isScratched?: Maybe<Scalars['Boolean']>;
  /** A history of price fluctuations based on the last traded prices. */
  readonly lastTradedFlucs?: Maybe<ReadonlyArray<PriceFluc>>;
  /** The decimal odds at which the most recent matched bet occurred. */
  readonly lastTradedPrice?: Maybe<Scalars['Float']>;
  /** The unique identifier for the market this selection belongs to. */
  readonly marketId: Scalars['String'];
  /** The name of the competitor. */
  readonly name: Scalars['String'];
  /** The runner number of the competitor. */
  readonly number: Scalars['Int'];
  /** Betfair's unique identifier for this specific selection. */
  readonly selectionId: Scalars['Int'];
  /** The current selling price. */
  readonly sellingPrice?: Maybe<Scalars['Float']>;
  /** The traded volume at the current selling price. */
  readonly sellingPriceTraded?: Maybe<Scalars['Float']>;
  /** The total amount of money that has been matched (both backed and layed) on this selection. */
  readonly totalTraded?: Maybe<Scalars['Float']>;
};

export enum BetType {
  All = 'ALL',
  Big6 = 'BIG6',
  DailyDouble = 'DAILY_DOUBLE',
  EarlyQuadrella = 'EARLY_QUADRELLA',
  Exacta = 'EXACTA',
  ExtraDouble = 'EXTRA_DOUBLE',
  FeatureDouble = 'FEATURE_DOUBLE',
  FirstFour = 'FIRST_FOUR',
  Omni = 'OMNI',
  OpeningFluc = 'OPENING_FLUC',
  Pentafecta = 'PENTAFECTA',
  Pick3 = 'PICK3',
  Pick4 = 'PICK4',
  Pick5 = 'PICK5',
  Pick6 = 'PICK6',
  Pick7 = 'PICK7',
  Pick8 = 'PICK8',
  Pick9 = 'PICK9',
  Pick10 = 'PICK10',
  PickX = 'PICK_X',
  Place = 'PLACE',
  Place_2 = 'PLACE_2',
  PlaceFixedOdds = 'PLACE_FIXED_ODDS',
  PlaceFixedOdds2 = 'PLACE_FIXED_ODDS2',
  Quadrella = 'QUADRELLA',
  Quinella = 'QUINELLA',
  QuinellaFixedOdds = 'QUINELLA_FIXED_ODDS',
  QuinellaPlace = 'QUINELLA_PLACE',
  RunningDouble = 'RUNNING_DOUBLE',
  SixUp = 'SIX_UP',
  SpecialDouble = 'SPECIAL_DOUBLE',
  StartingPrice = 'STARTING_PRICE',
  Superfecta = 'SUPERFECTA',
  TopFluc = 'TOP_FLUC',
  Treble = 'TREBLE',
  Trifecta = 'TRIFECTA',
  Trio = 'TRIO',
  VPick = 'V_PICK',
  Win = 'WIN',
  WinFixedOdds = 'WIN_FIXED_ODDS'
}

/** A container for a detailed breakdown of career statistics. */
export type Career = {
  readonly __typename?: 'Career';
  /** Overall career performance statistics. */
  readonly all?: Maybe<PlacingStats>;
  /** Career statistics broken down by specific, detailed categories. */
  readonly detail?: Maybe<Detail>;
  /** Career statistics related to performance after a spell (a break from racing). */
  readonly spell?: Maybe<Spell>;
  /** Career statistics grouped by various ranges. */
  readonly summary?: Maybe<Summary>;
};

export type Comment = {
  readonly __typename?: 'Comment';
  readonly comment: Scalars['String'];
  readonly source: Scalars['String'];
};

/** Contains a payload of new comments for a race, including both general race analysis and specific competitor insights. */
export type CommentUpdate = {
  readonly __typename?: 'CommentUpdate';
  /** A list of new comments, grouped by the specific competitor they refer to. */
  readonly competitorComments: ReadonlyArray<CompetitorComment>;
  /** A list of new comments that pertain to the race as a whole. */
  readonly raceComments: ReadonlyArray<Comment>;
  /** The id of the race to which these comments apply. */
  readonly raceId: Scalars['ID'];
};

export type Competitor = {
  readonly __typename?: 'Competitor';
  /** The age of the competitor in years. */
  readonly age: Scalars['Int'];
  /** The weight reduction (in kilograms) applied because the horse is ridden by an apprentice jockey. Returns 0 if the jockey is not an apprentice. */
  readonly allowanceWeight?: Maybe<Scalars['Float']>;
  /** A boolean flag that is `true` if the jockey is an apprentice, which typically entitles the horse to a weight allowance. */
  readonly apprenticeIndicator: Scalars['Boolean'];
  /** The competitor’s starting barrier, gate, or box number. */
  readonly barrier: Scalars['Int'];
  /** The best time recorded by the competitor for the race distance. Only for Greyhounds. */
  readonly bestTime: Scalars['String'];
  /** Indicates if the competitor is wearing blinkers. */
  readonly blinkers: Scalars['String'];
  /**
   * The coat color of the competitor, returned as an abbreviation.
   *
   * **Horse Colour Mappings:**
   * - 'unknown': Unknown
   * - 'ch': Chestnut
   * - 'bl': Black
   * - 'br': Brown
   * - 'b': Bay
   * - 'gr': Grey
   * - 'r': Red
   * - 'du': Dun
   * - 'be': Blue
   * - 'pa': Palomino
   * - 'pi': Perlino
   * - 'bk': Buckskin
   * - 'ro': Roan
   * - 'bd': Brindle
   * - 'wh': White
   * - 'pl': Pearl
   * - 'ta': Taffy
   * - 'f': Fawn
   * - 'ap': Appaloosa
   * - 'b/br': Bay Brown
   * - 'br/bl': Brown Black
   * - 'gr/ch': Grey Chestnut
   * - 'gr/b': Grey Bay
   * - 'gr/br': Grey Brown
   * - 'gr/bl': Grey Black
   * - 'gr/ro': Grey Roan
   * - 'du/ch': Dun Chestnut
   * - 'wh/b': White Bay
   * - 'wbk': White Black
   * - 'wbd': White Brindle
   * - 'bkw': Black White
   * - 'dkbd': Dark Brindle
   * - 'blbd': Black Brindle
   * - 'lf': Light Fawn
   * - 'wf': White Fawn
   * - 'rf': Red Fawn
   * - 'blf': Black Fawn
   * - 'lbr': Light Brown
   * - 'rbd': Red Brindle
   * - 'bdw': Brindle White
   * - 'ltbd': Light Brindle
   * - 'befw': Blue Fawn
   * - 'blblk': Blue Black
   * - 'bebd': Blue Brindle
   * - 'bew': Blue White
   * - 'wbe': White Blue
   * - 'wrf': White Red Fawn
   * - 'wrbd': White Red Brindle
   * - 'wdkbd': White Dark Brindle
   * - 'wbebd': White Blue Brindle
   * - 'bebdw': Blue Brindle White
   *
   * **Greyhound Colour Mappings:**
   * - 'unknown': Unknown
   * - 'be': Blue
   * - 'gr': Grey
   * - 'br': Brown
   * - 'f': Fawn
   * - 'R': Red
   * - 'bl': Black
   * - 'w': White
   * - 'bd': Brindle
   * - 'bebd': Blue Brindle
   * - 'bdw': Brindle White
   * - 'bef': Blue Fawn
   * - 'bkw': Black White
   * - 'bkbd': Black Brindle
   * - 'bew': Blue White
   * - 'dkbd': Dark Brindle
   * - 'ltbd': Light Brindle
   * - 'lf': Light Fawn
   * - 'rbd': Red Brindle
   * - 'rf': Red Fawn
   * - 'wbd': White Brindle
   * - 'wbk': White Black
   * - 'wf': White Fawn
   * - 'wbe': White Blue
   * - 'wrbd': White Red Brindle
   * - 'wrf': White Red Fawn
   * - 'wbebd': White Blue Brindle
   * - 'wdkbd': White Dark Brindle
   * - 'bebdw': Blue Brindle White
   */
  readonly colour: Scalars['String'];
  /** @deprecated comment is deprecated, use comments(source) instead */
  readonly comment: Scalars['String'];
  /** Analyst observations on how the competitor may perform in this race, filterable by language and source. */
  readonly comments: ReadonlyArray<SourceComment>;
  /** The country where the competitor was bred/foaled (ISO 3166-1 alpha-3 country code). */
  readonly country: Scalars['String'];
  /** A shared ID for two or more competitors “coupled” together as a single betting interest. This has limited jurisdictional coverage (e.g., USA). */
  readonly coupledRunnerId: Scalars['String'];
  /** Indicates if the competitor is a previous winner at the course (C), distance (D), or both (CD). */
  readonly courseDistanceWinner: Scalars['String'];
  /** The timestamp when the competitor was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** The name of the competitor's mother (dam). */
  readonly dam: Scalars['String'];
  /** The country where the dam was bred/foaled (ISO 3166-1 alpha-3 country code). */
  readonly damCountry: Scalars['String'];
  /** The name of the father of the competitor's dam. */
  readonly damSire: Scalars['String'];
  /** The number of days that have passed since the competitor’s most recent race. */
  readonly daysSinceLastRun?: Maybe<Scalars['Int']>;
  /** Indicates if the competitor is an emergency entrant for the race. */
  readonly emergencyIndicator: Scalars['Boolean'];
  /** Indicates if the competitor failed to finish their last race. */
  readonly failedToFinish: Scalars['Boolean'];
  /** The reason the competitor failed to finish, if applicable. */
  readonly failedToFinishReason: Scalars['String'];
  /** Favourite position and joint. */
  readonly favourites: ReadonlyArray<Favourite>;
  /** The official final finishing position of the competitor in the race. */
  readonly finalPosition?: Maybe<Scalars['Int']>;
  /** A history of the competitor's price fluctuations from a specific source and for a given price type. */
  readonly flucs: ReadonlyArray<PriceFluc>;
  /** The date the competitor was born (foaled). */
  readonly foalingDate?: Maybe<Scalars['TimeStamp']>;
  /** A history of the competitor's previous race performances. Note: This is not available in the `meetingsDated` or `races` queries. */
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  /** A description of any gear worn by the competitor for this race. */
  readonly gearChangesDescription: Scalars['String'];
  /** Prices generated by Betmakers' PriceManager product for this competitor. */
  readonly generatedPrice: ReadonlyArray<Price>;
  /** The competitor's positions at various points during the race, filterable by `source`. */
  readonly inRun: ReadonlyArray<InRun>;
  /** The name of the jockey (for THOROUGHBREDS) or driver (for HARNESS). */
  readonly jockey: Scalars['String'];
  /** The unique internal identifier for the jockey or driver. */
  readonly jockeyID: Scalars['ID'];
  /** Statistics for the jockey. Note: This is not available in the `meetingsDated` or `races` queries. */
  readonly jockeyStatistics?: Maybe<Statistics>;
  /** The time of a late scratching, if applicable. */
  readonly lateScratchingTime?: Maybe<Scalars['TimeStamp']>;
  /** The finishing margin in lengths between this competitor and the winner. Winner is set to 0. */
  readonly margin?: Maybe<Scalars['Float']>;
  /** Information on any medication the competitor has been administered. */
  readonly medication: Scalars['String'];
  /** The name of the competitor. */
  readonly name: Scalars['String'];
  /** The name(s) of the competitor's owners. */
  readonly owners: Scalars['String'];
  /** Performance ratings for the competitor. Note: This field is not available in `MeetingsDated` or `Races` queries and will return empty. */
  readonly performanceRatings: ReadonlyArray<PerformanceRating>;
  /** @deprecated No longer supported */
  readonly predictedRating: PredictedRating;
  /** A list of current betting prices for the competitor, filterable by source. */
  readonly prices: ReadonlyArray<Price>;
  /** The total prize money earned by the competitor throughout its entire career. */
  readonly prizeMoney: Scalars['Int'];
  /** A link back to the race this competitor is a part of. */
  readonly race: Race;
  /** The competitor's RACELAB insights, providing performance analytics. */
  readonly racelabInsights: RacelabInsights;
  /** The competitor's overall performance rating. Note: This field is not available in `MeetingsDated` or `Races` queries and will return empty. */
  readonly rating: Rating;
  /** The results for this competitor in the race, filterable by source and optionally including interim results. */
  readonly results: ReadonlyArray<ResultPosition>;
  /**
   * The starting row for the competitor, primarily used in Harness racing.
   *     - "FR" - First row.
   *     - "SR" - Second row.
   *     - "" - Unknown/Not applicable.
   */
  readonly row: Scalars['String'];
  /** The runner entity associated with this competitor. */
  readonly runner: Runner;
  /** Statistics for the runner. Note: This is not available in the `meetingsDated` or `races` queries. */
  readonly runnerStatistics?: Maybe<Statistics>;
  /** @deprecated scratched is deprecated, use scratchingType instead */
  readonly scratched: Scalars['Boolean'];
  /** The scratching status of the competitor (e.g., STARTER, SCRATCHED). */
  readonly scratchingType: ScratchingType;
  /** The external ID for this competitor from a specific data source. */
  readonly selectionID: Scalars['String'];
  /** The sex of the competitor (e.g., Colt, Filly, Gelding). */
  readonly sex: CompetitorSex;
  /** A text description of the jockey's silks (e.g., "Blue And White Checks, Green Sleeves And Cap"). This is not a color code and has no complex mapping. */
  readonly silksColour: Scalars['String'];
  /** A URL to an image of the jockey's silks. Available sizes: 20, 24, 32, 64, 128, 512. Size is not required if type is SVG (only available from AAP, PA and RP). */
  readonly silksURL: Scalars['String'];
  /** The name of the competitor's father (sire). */
  readonly sire: Scalars['String'];
  /** The country where the sire was bred/foaled (ISO 3166-1 alpha-3 country code). */
  readonly sireCountry: Scalars['String'];
  /** @deprecated No longer supported */
  readonly speedmapPosition?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  readonly speedmapValue: Scalars['Float'];
  /** For standing start (SS) harness races, this is the handicap distance, standardized to meters. Will be 0 for other codes or mobile starts. */
  readonly startingHandicap?: Maybe<Scalars['Int']>;
  /** The runner number assigned to the competitor. */
  readonly tabNo: Scalars['Int'];
  /** The name of the competitor's trainer. */
  readonly trainer: Scalars['String'];
  /** The unique internal identifier for the trainer. */
  readonly trainerID: Scalars['ID'];
  /** Statistics for the trainer. Note: This is not available in the `meetingsDated` or `races` queries. */
  readonly trainerStatistics?: Maybe<Statistics>;
  /** The location where the competitor is trained. */
  readonly trainingLocation: Scalars['String'];
  /** The timestamp of the last update to this competitor's information. */
  readonly updated: Scalars['TimeStamp'];
  /** The weight allocated to the competitor by the handicapper, standardized to kilograms. This value is converted from Pounds if the source data provides it in that unit. */
  readonly weightAllocated: Scalars['Float'];
  /** The total weight carried by the competitor during the race, standardized to kilograms. This should include the allocated weight plus any penalties or allowances. */
  readonly weightTotal: Scalars['Float'];
};


export type CompetitorCommentsArgs = {
  languages?: InputMaybe<ReadonlyArray<Language>>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type CompetitorCoupledRunnerIdArgs = {
  source: Scalars['String'];
};


export type CompetitorFavouritesArgs = {
  source?: InputMaybe<Scalars['String']>;
};


export type CompetitorFlucsArgs = {
  priceType?: InputMaybe<PriceType>;
  source: Scalars['String'];
};


export type CompetitorFormHistoryArgs = {
  maxRuns?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
};


export type CompetitorInRunArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type CompetitorJockeyStatisticsArgs = {
  source?: InputMaybe<Scalars['String']>;
};


export type CompetitorPerformanceRatingsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


export type CompetitorPricesArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


export type CompetitorResultsArgs = {
  includeInterim?: InputMaybe<Scalars['Boolean']>;
  sources: ReadonlyArray<Scalars['String']>;
};


export type CompetitorRunnerStatisticsArgs = {
  source?: InputMaybe<Scalars['String']>;
};


export type CompetitorSelectionIdArgs = {
  source: Scalars['String'];
};


export type CompetitorSilksUrlArgs = {
  size?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  sprite?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<SilksType>;
};


export type CompetitorTrainerStatisticsArgs = {
  source?: InputMaybe<Scalars['String']>;
};

export type CompetitorComment = {
  readonly __typename?: 'CompetitorComment';
  readonly comments: ReadonlyArray<Comment>;
  readonly name: Scalars['String'];
  readonly runnerNumber: Scalars['Int'];
};

/**
 * Represents the sex of a competitor.
 * - U: Unknown
 * - C: Colt (Thoroughbred)
 * - F: Filly (Thoroughbred)
 * - G: Gelding (Thoroughbred)
 * - H: Horse (Thoroughbred)
 * - M: Mare (Thoroughbred)
 * - R: Rig (Thoroughbred)
 * - D: Dog (Greyhound)
 * - B: Bitch (Greyhound)
 */
export enum CompetitorSex {
  /** Bitch - Female greyhound. */
  B = 'B',
  /** Colt - Young male horse that has not been gelded. */
  C = 'C',
  /** Dog - Male greyhound. */
  D = 'D',
  /** Filly - Young female horse. */
  F = 'F',
  /** Gelding - Castrated male horse. */
  G = 'G',
  /** Horse/Stallion - Adult male horse. */
  H = 'H',
  /** Mare - Adult female horse. */
  M = 'M',
  /** Rig - Male horse with one or both testicles undescended. */
  R = 'R',
  /** Unknown sex */
  U = 'U'
}

/** Contains a payload of real-time updates for a single competitor. */
export type CompetitorUpdate = {
  readonly __typename?: 'CompetitorUpdate';
  /** The age of the competitor in years. */
  readonly age: Scalars['Int'];
  /** The weight reduction (in kilograms) if the horse is ridden by an apprentice jockey. */
  readonly allowanceWeight?: Maybe<Scalars['Float']>;
  /** A boolean flag that is `true` if the jockey is an apprentice. */
  readonly apprenticeIndicator: Scalars['Boolean'];
  /** The starting barrier, gate, or box number for the competitor. */
  readonly barrier: Scalars['Int'];
  /** The country where the competitor was bred/foaled (ISO 3166-1 alpha-3 country code). */
  readonly country: Scalars['String'];
  /** The timestamp when the competitor was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** A flag indicating if the competitor is an emergency entrant. */
  readonly emergencyIndicator: Scalars['Boolean'];
  /** A flag indicating if the competitor failed to finish the current race. */
  readonly failedToFinish: Scalars['Boolean'];
  /** The reason the competitor failed to finish, if applicable. */
  readonly failedToFinishReason: Scalars['String'];
  /** The official final finishing position of the competitor. */
  readonly finalPosition?: Maybe<Scalars['Int']>;
  /** A description of any gear changes for this race. */
  readonly gearChangesDescription: Scalars['String'];
  /** The name of the jockey (for THOROUGHBREDS) or driver (for HARNESS). */
  readonly jockey: Scalars['String'];
  /** The unique internal identifier for the jockey or driver. */
  readonly jockeyID: Scalars['ID'];
  /** The time of a late scratching, if applicable. */
  readonly lateScratchingTime?: Maybe<Scalars['TimeStamp']>;
  /** The finishing margin in lengths between this competitor and the winner. Winner will be set to 0 */
  readonly margin?: Maybe<Scalars['Float']>;
  /** The name of the competitor. */
  readonly name: Scalars['String'];
  /**
   * The starting row for the competitor, primarily used in Harness racing.
   *     - "FR" - First row.
   *     - "SR" - Second row.
   *     - "" - Unknown/Not applicable.
   */
  readonly row: Scalars['String'];
  /** The unique runner entity associated with this competitor. */
  readonly runner: Runner;
  /** @deprecated scratched is deprecated, use scratchingType instead */
  readonly scratched: Scalars['Boolean'];
  /** The scratching status of the competitor (e.g., STARTER, SCRATCHED, LATESCRATCHING). */
  readonly scratchingType: ScratchingType;
  /** The sex of the competitor (e.g., Colt, Filly, Gelding). */
  readonly sex: CompetitorSex;
  /** A text description of the jockey's silks (e.g., "Blue And White Checks, Green Sleeves And Cap"). This is not a color code and has no complex mapping. */
  readonly silksColour: Scalars['String'];
  /** The runner number assigned to the competitor. */
  readonly tabNo: Scalars['Int'];
  /** The name of the competitor's trainer. */
  readonly trainer: Scalars['String'];
  /** The unique internal identifier for the trainer. */
  readonly trainerID: Scalars['ID'];
  /** The timestamp of this specific update. */
  readonly updated: Scalars['TimeStamp'];
  readonly weightAllocated: Scalars['Float'];
  readonly weightTotal: Scalars['Float'];
};

export type DateRange = {
  readonly from: Scalars['Time'];
  readonly to: Scalars['Time'];
};

/** Defines a range with a decimal start and end. */
export type DecimalRange = {
  readonly __typename?: 'DecimalRange';
  /** The end of the range (inclusive). */
  readonly end?: Maybe<Scalars['Float']>;
  /** The start of the range (inclusive). */
  readonly start?: Maybe<Scalars['Float']>;
};

/** Links a set of placing statistics to a specific decimal range. */
export type DecimalRangedPlacingStats = {
  readonly __typename?: 'DecimalRangedPlacingStats';
  /** The performance statistics for the specified range. */
  readonly placingStats?: Maybe<PlacingStats>;
  /** The decimal range these statistics apply to. */
  readonly range?: Maybe<DecimalRange>;
};

/** Details a specific deduction calculation for a defined period, including the runners that caused it. */
export type DeductionRule4 = {
  readonly __typename?: 'DeductionRule4';
  /** A list of the remaining active runners in the market at the time of the deduction. */
  readonly ActiveRunners: ReadonlyArray<ActiveRunnerRule4>;
  /** The start time of the period this deduction is valid for. */
  readonly FromTime: Scalars['TimeStamp'];
  /** A list of the withdrawn runners that caused this deduction. */
  readonly ScratchedRunners: ReadonlyArray<ScratchedRunnerRule4>;
  /** The end time of the period this deduction is valid for. */
  readonly ToTime: Scalars['TimeStamp'];
  /** The total deduction amount applied during this period. */
  readonly TotalDeduction: Scalars['Float'];
};

/** Contains all information related to a scratching event, including the withdrawn runner and the resulting official deductions for various bet types. */
export type DeductionSet = {
  readonly __typename?: 'DeductionSet';
  /** A list of the calculated deductions for various bet types resulting from this scratching. */
  readonly deductions: ReadonlyArray<Deductions>;
  /** The full Competitor object for the emergency runner. Note: This field is unavailable in subscription streams. */
  readonly emergencyCompetitor: Competitor;
  /** The runner number of the emergency competitor that replaces the scratched runner, if applicable. */
  readonly emergencyTabNo: Scalars['Int'];
  /** The unique identifier of the race where the scratching occurred. */
  readonly raceID: Scalars['ID'];
  /** The full Competitor object for the scratched runner. Note: This field is unavailable in subscription streams. */
  readonly scratchedCompetitor: Competitor;
  /** Deprecated. Use the `scratchedMedianPrice` on the `Deductions` type instead. */
  readonly scratchedMedianPrice: Scalars['Float'];
  /** The runner number of the competitor that was scratched. */
  readonly scratchedTabNo: Scalars['Int'];
  /** The timestamp when the competitor was officially scratched. */
  readonly scratchedTime: Scalars['TimeStamp'];
  /** The official source that declared the deduction. */
  readonly source: Scalars['String'];
  /** The status of this deduction event (e.g., INTERIM, FINAL). */
  readonly status: DeductionStatus;
};

export enum DeductionStatus {
  Final = 'FINAL',
  Interim = 'INTERIM',
  Unknown = 'UNKNOWN'
}

export enum DeductionType {
  Place = 'PLACE',
  Win = 'WIN'
}

/** Represents a specific deduction amount applied to a bet type, calculated based on the price of a scratched runner. */
export type Deductions = {
  readonly __typename?: 'Deductions';
  /** The deduction amount, expressed as cents in the dollar. */
  readonly deduction: Scalars['Float'];
  /** The median price of the scratched runner at the time of withdrawal, used to calculate the deduction. */
  readonly scratchedMedianPrice: Scalars['Float'];
  /** The bet type the deduction applies to (e.g., WIN, PLACE). */
  readonly type: DeductionType;
};

export type Derivative = {
  readonly __typename?: 'Derivative';
  readonly marketId: Scalars['String'];
  readonly marketType: Scalars['String'];
  readonly raceId: Scalars['ID'];
  readonly races: ReadonlyArray<DerivativeRace>;
  readonly selectedMarkets: ReadonlyArray<DerivativeSelectedMarket>;
  readonly source: Scalars['String'];
  readonly status: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updateType: Scalars['String'];
  readonly updated?: Maybe<Scalars['TimeStamp']>;
};

export type DerivativeRace = {
  readonly __typename?: 'DerivativeRace';
  readonly number: Scalars['Int'];
  readonly results: ReadonlyArray<DerivativeResult>;
  readonly rule4Deductions: ReadonlyArray<Maybe<DeductionRule4>>;
  readonly runners: ReadonlyArray<DerivativeRunner>;
};

/** Represents the result of a single outcome within a derivative market, including any dead heat reductions. */
export type DerivativeResult = {
  readonly __typename?: 'DerivativeResult';
  /** A code representing the result outcome. */
  readonly code: Scalars['String'];
  /** The reduction factor applied to payouts in the event of a dead heat. */
  readonly deadHeatReduction: Scalars['Float'];
  /** The number of the runner or selection this result applies to. */
  readonly number: Scalars['Int'];
};

export type DerivativeRunner = {
  readonly __typename?: 'DerivativeRunner';
  /** A user-friendly string representation of the price at 2 decimal places. */
  readonly displayPrice: Scalars['String'];
  /** A textual representation of the derivative market outcome corresponding to number. */
  readonly name: Scalars['String'];
  /** A unique identifier representing a runner or outcome within the market. */
  readonly number: Scalars['Int'];
  /** The raw decimal value of the odds. */
  readonly price: Scalars['Float'];
  /** A list of all runner numbers associated with this market outcome. */
  readonly selectionRunners?: Maybe<ReadonlyArray<Scalars['Int']>>;
  /** The owning source of the market. */
  readonly source: Scalars['String'];
  /** The ScratchingType of this selection when it is associated with an individual runner. */
  readonly status: Scalars['String'];
};

export type DerivativeSelectedMarket = {
  readonly __typename?: 'DerivativeSelectedMarket';
  readonly meetingID: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
};

/** Career statistics broken down by specific, detailed categories. */
export type Detail = {
  readonly __typename?: 'Detail';
  /** Stats by race class. */
  readonly byClass?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats by track condition. */
  readonly byCondition?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats by race distance. */
  readonly byDistance?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats by a combination of distance and condition. */
  readonly byDistanceAndCondition?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats by jockey. */
  readonly byJockey?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats for jumps races. */
  readonly byJumps?: Maybe<PlacingStats>;
  /** Stats by race condition (e.g., Handicap). */
  readonly byRaceCondition?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats by track surface. */
  readonly bySurface?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats by track. */
  readonly byTrack?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats by a combination of track and distance. */
  readonly byTrackAndDistance?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats for official trials. */
  readonly byTrails?: Maybe<PlacingStats>;
  /** Stats by trainer. */
  readonly byTrainer?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats for a specific trainer and jockey combination. */
  readonly byTrainerAndJockey?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Stats by weight carried. */
  readonly byWeight?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Miscellaneous statistics. */
  readonly misc?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
};

/** Represents an exotic bet, which involves multiple outcomes either within a single race (e.g., Trifecta) or across multiple races (e.g., Quadrella). This type provides all the details needed to display, price, and place the bet. */
export type Exotic = {
  readonly __typename?: 'Exotic';
  /** A list of the declared dividends for winning combinations. */
  readonly dividends: ReadonlyArray<ExoticDividend>;
  /** A list of the individual races (legs) that make up this exotic bet. */
  readonly exoticRaces: ReadonlyArray<ExoticRace>;
  /** The unique internal identifier for this specific exotic bet. */
  readonly id: Scalars['String'];
  /** A boolean flag that is `true` if this exotic bet spans across multiple, separate meetings, making it a special event. */
  readonly isCrossMeeting: Scalars['Boolean'];
  /** The total size of the betting pool for this exotic. */
  readonly poolSize: Scalars['Int'];
  /** @deprecated races are being deprecated, use exoticRaces instead */
  readonly races: ReadonlyArray<Race>;
  /** The final results of the exotic bet, including winning combinations and payouts. */
  readonly results: ReadonlyArray<ExoticResult>;
  /** The data provider (e.g., a specific tote) offering this exotic bet. */
  readonly source: Scalars['String'];
  /** The identifier for this exotic bet from the specified data source. */
  readonly sourceId: Scalars['String'];
  /** The specific name of the exotic bet. if applicable. */
  readonly specialName: Scalars['String'];
  /** A list of associated tote products for this exotic bet, containing details on pool variations, bet styles, and stake limits. */
  readonly toteProducts: ReadonlyArray<ToteProduct>;
  /** The generic type of exotic bet (e.g., PICK4, TRIFECTA). This defines the general bet selection and placement behavior. */
  readonly type: BetType;
};

/** Maps a competitor's runner number to the unique selection ID required by the betting system to place exotic bets. */
export type ExoticCompetitor = {
  readonly __typename?: 'ExoticCompetitor';
  /** The competitor's official runner number for the race. */
  readonly runnerNumber: Scalars['Int'];
  /** The unique identifier for this competitor within the betting system, used when constructing bets. */
  readonly selectionId: Scalars['String'];
};

/** Represents a single dividend payout for a specific winning combination in an exotic bet. There can be multiple dividends if there are dead heats. */
export type ExoticDividend = {
  readonly __typename?: 'ExoticDividend';
  /** An array of runner numbers representing the winning combination. */
  readonly combination: ReadonlyArray<Scalars['Int']>;
  /** The price or dividend paid for this specific winning combination. */
  readonly price?: Maybe<Scalars['Float']>;
};

/** Represents a single race (or leg) within a multi-leg exotic bet. */
export type ExoticRace = {
  readonly __typename?: 'ExoticRace';
  /** A list of the competitors participating in this leg of the exotic, with their betting selection IDs. */
  readonly competitors: ReadonlyArray<ExoticCompetitor>;
  /** The unique identifier of the meeting this race belongs to. */
  readonly meetingId: Scalars['ID'];
  /** The full race object for this leg of the exotic, allowing access to all race details. */
  readonly race?: Maybe<Race>;
  /** The number of the race within its meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The selection ID for the 'unnamed favourite' option in this leg of the exotic bet. This allows a bet to be placed on whichever competitor becomes the official favourite at the start of the race, without selecting a specific runner in advance. This feature is typically supported for specific tote pools, often in UK racing. */
  readonly unnamedFavouriteSelectionId: Scalars['String'];
};

/** Describes the final result of an exotic bet, including the winning numbers and the dividend paid. */
export type ExoticResult = {
  readonly __typename?: 'ExoticResult';
  /** The final payout amount for a winning ticket. */
  readonly dividend: Scalars['Float'];
  /** A string representing the winning combination of runner numbers (e.g., '1,5,10'). */
  readonly dividendNumbers: Scalars['String'];
  /** The total size of the prize pool for this result. */
  readonly poolSize: Scalars['Float'];
};

/** Contains a real-time update payload for an exotic bet. */
export type ExoticUpdate = {
  readonly __typename?: 'ExoticUpdate';
  /** The updated list of dividends. */
  readonly dividends: ReadonlyArray<ExoticDividend>;
  /** Indicates if the exotic bet spans multiple meetings. */
  readonly isCrossMeeting: Scalars['Boolean'];
  /** The updated total size of the betting pool. */
  readonly poolSize: Scalars['Int'];
  /** A list of the races (legs) involved in this exotic bet with updated information. */
  readonly races: ReadonlyArray<ExoticRace>;
  /** The updated results for the exotic bet. */
  readonly results: ReadonlyArray<ExoticResult>;
  /** The data provider for this exotic bet. */
  readonly source: Scalars['String'];
  /** The specific name of the exotic bet, if applicable. */
  readonly specialName: Scalars['String'];
  /** The type of exotic bet being updated. */
  readonly type: BetType;
};

export type Favourite = {
  readonly __typename?: 'Favourite';
  readonly Joint: Scalars['Int'];
  readonly Position: Scalars['Int'];
  readonly Source: Scalars['String'];
};

/** A generic input object used to define a key-value pair for filtering query results. */
export type Filter = {
  /** The field to filter on, chosen from the `FilterKey` enum. */
  readonly key: FilterKey;
  /** The value to use for the filter. */
  readonly value: Scalars['String'];
};

export enum FilterKey {
  Country = 'Country',
  MeetingType = 'MeetingType'
}

/** Provides a summary of another placed competitor within a past race, used to add context to a form line. */
export type FormPlaceGetter = {
  readonly __typename?: 'FormPlaceGetter';
  /** The barrier number of the placed competitor. */
  readonly barrier: Scalars['Int'];
  /** The reason the competitor failed to finish, if applicable. */
  readonly failedToFinishReason: Scalars['String'];
  /** The official finishing position of the placed competitor. */
  readonly finishingPosition: Scalars['Int'];
  /** The unique global identifier for the placed runner's jockey. */
  readonly jockeyGlobalId: Scalars['ID'];
  /** The name of the placed runner's jockey. */
  readonly jockeyName: Scalars['String'];
  readonly margin: Scalars['Float'];
  /** The name of the placed runner. */
  readonly name: Scalars['String'];
  /** The unique global identifier for the placed runner. */
  readonly runnerGlobalId: Scalars['ID'];
  /** The starting price of the placed competitor. */
  readonly startingPrice: Scalars['Float'];
  /** The runner number of the placed competitor. */
  readonly tabNumber: Scalars['Int'];
  /** The unique global identifier for the placed runner's trainer. */
  readonly trainerGlobalId: Scalars['ID'];
  /** The name of the placed runner's trainer. */
  readonly trainerName: Scalars['String'];
  /** The weight carried by the placed competitor. */
  readonly weight: Scalars['Float'];
};

export type FormStatsUpdated = {
  readonly __typename?: 'FormStatsUpdated';
  /** The gbs Id of the updated form. */
  readonly gbsId: Scalars['String'];
  /** The id of the race whose form has been updated. */
  readonly id: Scalars['ID'];
  /** The race number of the updated form. */
  readonly raceNumber: Scalars['Int'];
  /** The racing type - RACING for normal racing, FUTURE for futures. */
  readonly racingType: RacingType;
  /** The global runner ID (only present for FUTURE racing type). */
  readonly runnerId?: Maybe<Scalars['String']>;
  /** The source of the updated form. */
  readonly source: Scalars['String'];
  /** The type of the updated form. */
  readonly type: FormStatsUpdatedType;
};

export enum FormStatsUpdatedType {
  Form = 'FORM',
  JockeyStatistics = 'JOCKEY_STATISTICS',
  RunnerStatistics = 'RUNNER_STATISTICS',
  TrainerStatistics = 'TRAINER_STATISTICS'
}

/** Represents fractional timing data for a race, common in North American racing. */
export type Fraction = {
  readonly __typename?: 'Fraction';
  /** An identifier for the fraction (e.g., '1' for the first quarter mile). */
  readonly fractionNumber: Scalars['String'];
  /** A human-readable display of the fraction time. */
  readonly fractionPrint: Scalars['String'];
  /** The time for this fraction, often in hundredths of a second. */
  readonly time: Scalars['Int'];
};

export type Futures = {
  readonly __typename?: 'Futures';
  readonly event: ReadonlyArray<FuturesEvent>;
  readonly serverTimestamp: Scalars['Int'];
};

export type FuturesEvent = {
  readonly __typename?: 'FuturesEvent';
  readonly acceptanceRaceNumber?: Maybe<Scalars['Int']>;
  readonly class: Scalars['String'];
  readonly country: Scalars['String'];
  readonly date: Scalars['Time'];
  readonly distance: Scalars['String'];
  readonly entryCondition: Scalars['String'];
  readonly externalIDs?: Maybe<ReadonlyArray<Maybe<SourceId>>>;
  readonly id: Scalars['Int'];
  readonly markets?: Maybe<ReadonlyArray<FuturesMarket>>;
  readonly meetingId: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly prizeMoney: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
  readonly sportCategoryDescription: Scalars['String'];
  readonly sportCategoryId: Scalars['Int'];
  readonly sportTypeId: Scalars['Int'];
  readonly stage: Scalars['String'];
  readonly state: Scalars['String'];
  readonly status?: Maybe<FuturesEventStatus>;
  readonly urls?: Maybe<ReadonlyArray<FuturesUrl>>;
  readonly venue: Scalars['String'];
};


export type FuturesEventExternalIDsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};

export enum FuturesEventStatus {
  Open = 'Open',
  Resulted = 'Resulted',
  Suspended = 'Suspended'
}

export type FuturesForm = {
  readonly __typename?: 'FuturesForm';
  readonly SP: Scalars['Float'];
  readonly barrier: Scalars['Int'];
  readonly class: Scalars['String'];
  readonly date: Scalars['Time'];
  readonly distance: Scalars['Int'];
  readonly elapsedTime: Scalars['String'];
  readonly jockey: Scalars['String'];
  readonly margin: Scalars['Float'];
  readonly placing: Scalars['String'];
  readonly raceNo: Scalars['Int'];
  readonly startCount: Scalars['Int'];
  readonly starters: Scalars['Int'];
  readonly state: Scalars['String'];
  readonly stewardsComment: Scalars['String'];
  readonly trackCondition: Scalars['String'];
  readonly trackRating: Scalars['Int'];
  readonly trainer: Scalars['String'];
  readonly venue: Scalars['String'];
  readonly weight: Scalars['Float'];
};

export type FuturesMarket = {
  readonly __typename?: 'FuturesMarket';
  readonly selections?: Maybe<ReadonlyArray<FuturesSelection>>;
  readonly type: Scalars['String'];
};

/** Provides details about the next scheduled race for a futures competitor. */
export type FuturesNextRace = {
  readonly __typename?: 'FuturesNextRace';
  readonly details: Scalars['String'];
  /** The unique identifier of the meeting for the next race. */
  readonly meetingId?: Maybe<Scalars['ID']>;
  /** The number of the next race. */
  readonly raceNumber?: Maybe<Scalars['Int']>;
};

/** Represents the odds for a single futures selection from a specific data provider at a point in time. */
export type FuturesPrice = {
  readonly __typename?: 'FuturesPrice';
  /** The decimal odds for the selection. */
  readonly price: Scalars['Float'];
  /** The data provider offering this price. */
  readonly source: Scalars['String'];
  /** The timestamp when this price was last updated. */
  readonly updated: Scalars['Time'];
};

/** Represents a single competitor (a 'selection') within a legacy futures market, containing its odds, form, and status. */
export type FuturesSelection = {
  readonly __typename?: 'FuturesSelection';
  /** The unique identifier for the selection from AAP. */
  readonly aapID: Scalars['Int'];
  /** The runner number assigned after final acceptances. Will be null before the final field is declared. */
  readonly acceptanceRunnerNumber?: Maybe<Scalars['Int']>;
  /** A history of the competitor's previous race performances. */
  readonly form?: Maybe<ReadonlyArray<FuturesForm>>;
  /** Prices generated by PriceManager. */
  readonly generatedPrice: ReadonlyArray<Price>;
  /** The unique identifier for the selection within the market. */
  readonly marketSelectionId: Scalars['Int'];
  /** The name of the competitor. */
  readonly name: Scalars['String'];
  /** Details about the competitor's next scheduled race prior to this futures event. */
  readonly nextRace?: Maybe<FuturesNextRace>;
  /** The final finishing position of the competitor if the event has been resulted. */
  readonly placing?: Maybe<Scalars['Int']>;
  /** A list of current odds available from various data providers. */
  readonly prices?: Maybe<ReadonlyArray<FuturesPrice>>;
  /** The reason the selection was removed from the market, if applicable. */
  readonly removedReason?: Maybe<FuturesSelectionReason>;
  /** The time the selection was removed from the market, if applicable. */
  readonly removedTime?: Maybe<Scalars['Time']>;
  /** The runner number assigned to the competitor in the futures market. */
  readonly runnerNumber: Scalars['Int'];
  /** Information about the owner's racing silks. */
  readonly silk?: Maybe<FuturesSilks>;
  /** A summary of the competitor's recent performance statistics. */
  readonly stats?: Maybe<FuturesStats>;
  /** The current status of the selection in the market (e.g., Active, Suspended). */
  readonly status: FuturesSelectionStatus;
  /** The name of the competitor's trainer. */
  readonly trainer: Scalars['String'];
};

export enum FuturesSelectionReason {
  Injury = 'Injury',
  Na = 'NA',
  NotNominated = 'NotNominated'
}

export enum FuturesSelectionStatus {
  Active = 'Active',
  Injury = 'Injury',
  Loss = 'Loss',
  NotNominated = 'NotNominated',
  Place = 'Place',
  Suspended = 'Suspended',
  Void = 'Void',
  Win = 'Win'
}

/** Contains the description and an image URL for the owner's racing silks. */
export type FuturesSilks = {
  readonly __typename?: 'FuturesSilks';
  /** A text description of the silks' colors and patterns. */
  readonly colours: Scalars['String'];
  /** A URL to an image of the silks. */
  readonly image: Scalars['String'];
};

/** A summary of a competitor's recent performance statistics. */
export type FuturesStats = {
  readonly __typename?: 'FuturesStats';
  /** A string representing the finishing positions of the last 6 starts (e.g., '1x243'). */
  readonly last6: Scalars['String'];
  /** A string representing the finishing positions of the last 10 starts. */
  readonly last10: Scalars['String'];
};

export type FuturesUrl = {
  readonly __typename?: 'FuturesUrl';
  readonly URL: Scalars['String'];
  readonly source: Scalars['String'];
};

/** Represents a major future racing event (e.g., a championship race) for which betting is open in advance. */
export type FuturesV2Event = {
  readonly __typename?: 'FuturesV2Event';
  /** The matching acceptance race for this futures event, if available. */
  readonly acceptance?: Maybe<Race>;
  /** The class or grade of the event (e.g., 'Group 1'). */
  readonly class: Scalars['String'];
  /** The country where the event will be held. */
  readonly country: Scalars['String'];
  /** The timestamp when the futures event was created. */
  readonly created: Scalars['TimeStamp'];
  /**
   * The distance of the race, standardized to meters. This value is calculated from various source units (e.g., Furlongs, Yards, Kilometers) and rounded to the nearest integer. Data is not always consistent, we try our best to ensure it's in meters.
   *
   * METERS: value
   * FURLONGS: value * 201.168
   * KILOMETERS: value * 1000
   * MILES: value * 1609.34
   * YARDS: value * 0.9144
   * FEET: value * 0.3048
   */
  readonly distance: Scalars['Int'];
  readonly entryCondition: Scalars['String'];
  readonly gbsId?: Maybe<Scalars['String']>;
  readonly gbsRaceNumber?: Maybe<Scalars['Int']>;
  /** The unique internal identifier for the futures event. */
  readonly id: Scalars['ID'];
  /** The official name of the event (e.g., 'The Everest'). */
  readonly name: Scalars['String'];
  /** The total prize money for the event. */
  readonly prize: Scalars['Int'];
  /** A list of the runners currently in the market for this event. */
  readonly runners: ReadonlyArray<FuturesV2Runner>;
  /** The current stage of the event (e.g., NOMINATIONS, FINAL_FIELD). */
  readonly stage: FuturesV2EventStage;
  /** The scheduled date and time of the event. */
  readonly startTime: Scalars['TimeStamp'];
  /** The state or region where the event will be held. */
  readonly state: Scalars['String'];
  /** The current status of the event market (e.g., OPEN, SUSPENDED, RESULTED). */
  readonly status: FuturesV2EventStatus;
  /** The type of racing (e.g., THOROUGHBRED). */
  readonly type: MeetingType;
  /** The timestamp of the last update to the event's information. */
  readonly updated: Scalars['TimeStamp'];
  /** The name of the venue or track hosting the event. */
  readonly venue: Scalars['String'];
};

export enum FuturesV2EventStage {
  FinalField = 'FINAL_FIELD',
  Nominations = 'NOMINATIONS',
  PreNominations = 'PRE_NOMINATIONS'
}

export enum FuturesV2EventStatus {
  Open = 'OPEN',
  Resulted = 'RESULTED',
  Suspended = 'SUSPENDED'
}

/** A real-time update payload containing changes to a futures event, such as status, stage, or runner information. */
export type FuturesV2EventUpdate = {
  readonly __typename?: 'FuturesV2EventUpdate';
  /** The updated class or grade of the event. */
  readonly class: Scalars['String'];
  /** The updated distance of the event. */
  readonly distance: Scalars['Int'];
  /** The unique identifier for the event being updated. */
  readonly id: Scalars['ID'];
  /** The updated prize money for the event. */
  readonly prize: Scalars['Int'];
  /** A list of runner updates included in this event update. */
  readonly runners: ReadonlyArray<FuturesV2RunnerUpdate>;
  /** The event's new stage (e.g., NOMINATIONS, FINAL_FIELD). */
  readonly stage: FuturesV2EventStage;
  /** The event's new market status (e.g., OPEN, SUSPENDED, RESULTED). */
  readonly status: FuturesV2EventStatus;
  /** The timestamp of this specific update. */
  readonly updated?: Maybe<Scalars['TimeStamp']>;
};

/** Represents a single competitor (runner) within a futures event market. */
export type FuturesV2Runner = {
  readonly __typename?: 'FuturesV2Runner';
  /** The age of the runner in years. */
  readonly age?: Maybe<Scalars['Int']>;
  /** The colour/coat of the runner. */
  readonly colour?: Maybe<Scalars['String']>;
  /** The timestamp when this runner was added to the futures event. */
  readonly created: Scalars['TimeStamp'];
  /** The name of the runner's dam (mother). */
  readonly dam?: Maybe<Scalars['String']>;
  /** A history of the runner's previous race performances. */
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  /** Only for PriceManager clients. Prices generated by PriceManager. */
  readonly generatedPrice: ReadonlyArray<Price>;
  /** The unique internal identifier for the runner. */
  readonly id: Scalars['ID'];
  /** The name of the runner. */
  readonly name: Scalars['String'];
  /** The name(s) of the runner's owner(s). */
  readonly owners?: Maybe<Scalars['String']>;
  /** The total prize money won by the runner. */
  readonly prizeMoney?: Maybe<Scalars['Int']>;
  /** The sex of the runner (e.g., C=Colt, F=Filly, G=Gelding, H=Horse, M=Mare). */
  readonly sex?: Maybe<Scalars['String']>;
  /** A description of the owner's racing silks (colors and patterns). */
  readonly silks: Scalars['String'];
  /** The name of the runner's sire (father). */
  readonly sire?: Maybe<Scalars['String']>;
  /** Statistics for the runner. */
  readonly stats: Statistics;
  /** The current status of the runner in the market (e.g., ACTIVE, SUSPENDED). */
  readonly status: FuturesV2RunnerStatus;
  /** The runner number assigned to the competitor in the futures market. */
  readonly tabNo: Scalars['Int'];
  /** The timestamp of the last update to this runner's information. */
  readonly updated: Scalars['TimeStamp'];
};


/** Represents a single competitor (runner) within a futures event market. */
export type FuturesV2RunnerFormHistoryArgs = {
  maxRuns?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
};


/** Represents a single competitor (runner) within a futures event market. */
export type FuturesV2RunnerStatsArgs = {
  source?: InputMaybe<Scalars['String']>;
};

export enum FuturesV2RunnerStatus {
  Active = 'ACTIVE',
  Loss = 'LOSS',
  Place = 'PLACE',
  Suspended = 'SUSPENDED',
  Void = 'VOID',
  Win = 'WIN'
}

/** A real-time update payload for a single runner within a futures event market. */
export type FuturesV2RunnerUpdate = {
  readonly __typename?: 'FuturesV2RunnerUpdate';
  /** The unique identifier of the event this runner belongs to. */
  readonly eventId: Scalars['ID'];
  /** The unique identifier for the runner. */
  readonly id: Scalars['ID'];
  /** An updated description of the owner's racing silks. */
  readonly silks: Scalars['String'];
  /** The runner's new status in the market (e.g., ACTIVE, SUSPENDED). */
  readonly status: FuturesV2RunnerStatus;
  /** The timestamp of this specific update. */
  readonly updated?: Maybe<Scalars['TimeStamp']>;
};

export enum GateRangeType {
  GateRangeTypeInner = 'GATE_RANGE_TYPE_INNER',
  GateRangeTypeMiddle = 'GATE_RANGE_TYPE_MIDDLE',
  GateRangeTypeOuter = 'GATE_RANGE_TYPE_OUTER',
  GateRangeTypeUnknown = 'GATE_RANGE_TYPE_UNKNOWN'
}

export type GeneratedExotic = {
  readonly __typename?: 'GeneratedExotic';
  /** Type of exotic (Exacta, Trifecta, etc). */
  readonly exoticType: GeneratedExoticType;
  /** Unique identifier for this market. */
  readonly marketId: Scalars['String'];
  /** Odds for each possible outcome of that exotic market. */
  readonly prices?: Maybe<ReadonlyArray<GeneratedExoticPrice>>;
  /** The race associated with this market. */
  readonly raceID: Scalars['ID'];
  /** The client associated with this market. */
  readonly source: Scalars['String'];
  /** Status of this market. */
  readonly status: GeneratedExoticStatus;
  /** Timestamp of last update. */
  readonly updated?: Maybe<Scalars['TimeStamp']>;
};

export type GeneratedExoticPrice = {
  readonly __typename?: 'GeneratedExoticPrice';
  /** A list of all runner numbers associated with this market outcome. */
  readonly combinations?: Maybe<ReadonlyArray<Scalars['Int']>>;
  /** The raw decimal value of the odds. */
  readonly price: Scalars['Float'];
};

export enum GeneratedExoticStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Suspended = 'SUSPENDED',
  Unknown = 'UNKNOWN',
  Void = 'VOID'
}

export enum GeneratedExoticType {
  Exacta = 'EXACTA',
  FirstFour = 'FIRST_FOUR',
  Quinella = 'QUINELLA',
  QuinellaPlace = 'QUINELLA_PLACE',
  Superfecta = 'SUPERFECTA',
  Trifecta = 'TRIFECTA',
  Trio = 'TRIO',
  Unknown = 'UNKNOWN'
}

export enum HarnessStartType {
  Mobile = 'Mobile',
  Standing = 'Standing'
}

export type InRun = {
  readonly __typename?: 'InRun';
  readonly distance: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly source: Scalars['String'];
};

/** Defines a range with an integer start and end. */
export type Int32Range = {
  readonly __typename?: 'Int32Range';
  /** The end of the range (inclusive). */
  readonly end?: Maybe<Scalars['Int']>;
  /** The start of the range (inclusive). */
  readonly start?: Maybe<Scalars['Int']>;
};

/** Links a set of placing statistics to a specific integer range. */
export type Int32RangedPlacingStats = {
  readonly __typename?: 'Int32RangedPlacingStats';
  /** The performance statistics for the specified range. */
  readonly placingStats?: Maybe<PlacingStats>;
  /** The integer range these statistics apply to. */
  readonly range?: Maybe<Int32Range>;
};

export type JockeyIdentifier = {
  readonly __typename?: 'JockeyIdentifier';
  readonly globalId: Scalars['ID'];
  readonly meetingType: Scalars['String'];
  readonly name: Scalars['String'];
};

export type JockeyResult = {
  readonly __typename?: 'JockeyResult';
  readonly jockeyIdentifier: JockeyIdentifier;
  readonly sourceJockeys: ReadonlyArray<Maybe<JockeyIdentifier>>;
  readonly targetJockey: JockeyIdentifier;
};

/** A set of performance statistics for a specific key (e.g., a track name, a jockey's name). */
export type KeyedPlacingStats = {
  readonly __typename?: 'KeyedPlacingStats';
  /** The average starting price. */
  readonly averagePrice: Scalars['Float'];
  /** The average prize money won per run. */
  readonly averagePrizeMoneyWon: Scalars['Float'];
  /** The average time taken to run, in seconds. */
  readonly averageTimeSeconds: Scalars['Float'];
  /** The best mile rate achieved, in seconds. */
  readonly bestMileRateSeconds: Scalars['Float'];
  /** The best time achieved, in seconds. */
  readonly bestTimeSeconds: Scalars['Float'];
  /** The largest single prize money amount won. */
  readonly biggestPrizeMoneyWon: Scalars['Float'];
  /** The total number of 1st place finishes. */
  readonly firsts: Scalars['Int'];
  /** The key for which these stats were calculated (e.g., 'Eagle Farm', 'GOOD4'). */
  readonly key: Scalars['String'];
  /** The time from the most recent run, in seconds. */
  readonly lastTimeSeconds: Scalars['Float'];
  /** The total number of runs included in this statistic. */
  readonly numberOfRuns: Scalars['Int'];
  /** The percentage of runs that resulted in a top-3 finish. */
  readonly placePercentage: Scalars['Int'];
  /** A performance rating score. */
  readonly rating: Scalars['Float'];
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly returnOnInvestment?: Maybe<ReturnOnInvestment>;
  /** The average starting price, rounded. */
  readonly roundedAveragePrice: Scalars['Float'];
  /** The average prize money won, rounded. */
  readonly roundedAveragePrizeMoneyWon: Scalars['Float'];
  /** The total number of 2nd place finishes. */
  readonly seconds: Scalars['Int'];
  /** The total number of 3rd place finishes. */
  readonly thirds: Scalars['Int'];
  /** The percentage of runs that resulted in a top-2 finish. */
  readonly top2Percentage: Scalars['Int'];
  /** The percentage of runs that resulted in a top-3 finish. */
  readonly top3Percentage: Scalars['Int'];
  /** The percentage of runs that resulted in a top-4 finish. */
  readonly top4Percentage: Scalars['Int'];
  /** The total prize money won. */
  readonly totalPrizeMoneyWon: Scalars['Float'];
  /** The win percentage (firsts / numberOfRuns). */
  readonly winPercentage: Scalars['Int'];
};

export enum Language {
  English = 'ENGLISH',
  PortugueseBrazilian = 'PORTUGUESE_BRAZILIAN'
}

export type LiveForm = {
  readonly __typename?: 'LiveForm';
  /** average odds of winning competitors. */
  readonly averageOdds?: Maybe<LiveFormAverageOdds>;
  /** number of races won by the favourite. */
  readonly favouritePerformance?: Maybe<LiveFormFavouritePerformance>;
  /** % of winners that have come from the specified gates. Defaults to 1-3 if no gates specified. */
  readonly gatePerformance?: Maybe<LiveFormGatesPerformance>;
  /** % of winners that have come from the gates. */
  readonly gateRangePerformance?: Maybe<ReadonlyArray<LiveFormGateRangePerformanceNew>>;
  /** number of races won by the market movers. */
  readonly marketMovers?: Maybe<LiveFormMarketMovers>;
  /** % of driver that have the most wins. Only HARNESS. */
  readonly topDrivers?: Maybe<ReadonlyArray<LiveFormTopDriverNew>>;
  /** % of gates that have the most wins. Only THOROUGHBREDS and GREYHOUNDS. */
  readonly topGates?: Maybe<ReadonlyArray<LiveFormGatePerformanceNew>>;
  /** % of jockey that have the most wins. Only THOROUGHBREDS. */
  readonly topJockeys?: Maybe<ReadonlyArray<LiveFormTopJockeyNew>>;
  /** % of trainers that have the most wins. */
  readonly topTrainers?: Maybe<ReadonlyArray<LiveFormTopTrainerNew>>;
  /** % of winner that have come from settling track position */
  readonly trackBias?: Maybe<ReadonlyArray<LiveFormTrackBias>>;
};


export type LiveFormAverageOddsArgs = {
  source: Scalars['String'];
};


export type LiveFormFavouritePerformanceArgs = {
  source: Scalars['String'];
};


export type LiveFormGatePerformanceArgs = {
  gates?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};


export type LiveFormMarketMoversArgs = {
  source: Scalars['String'];
};

export type LiveFormAverageOdds = {
  readonly __typename?: 'LiveFormAverageOdds';
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** average odds of the resulted rides during this meeting. */
  readonly value: Scalars['Float'];
};

export type LiveFormFavouritePerformance = {
  readonly __typename?: 'LiveFormFavouritePerformance';
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** percentage of races won by the favorite during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the favorite during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormGatePerformance = {
  readonly __typename?: 'LiveFormGatePerformance';
  /** gate/barrier */
  readonly gate: Scalars['Int'];
  /** Is the gate considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** gate's remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormGatePerformanceNew = {
  readonly __typename?: 'LiveFormGatePerformanceNew';
  /** gate/barrier */
  readonly gate: Scalars['Int'];
  /** Is the gate considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** gate's remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};


export type LiveFormGatePerformanceNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormGateRangePerformance = {
  readonly __typename?: 'LiveFormGateRangePerformance';
  /** gate/barrier range as INNER, MIDDLE or OUTER */
  readonly gateRangeType: GateRangeType;
  /** Is the gate range considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** gate range’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
};

export type LiveFormGateRangePerformanceNew = {
  readonly __typename?: 'LiveFormGateRangePerformanceNew';
  /** gate/barrier range as INNER, MIDDLE or OUTER */
  readonly gateRangeType: GateRangeType;
  /** Is the gate range considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** gate range’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
};


export type LiveFormGateRangePerformanceNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormGatesPerformance = {
  readonly __typename?: 'LiveFormGatesPerformance';
  /** gate/barrier */
  readonly gates: ReadonlyArray<Scalars['Int']>;
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** percentage of races won from this gate range during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this gate range during this meeting. */
  readonly winCount: Scalars['Int'];
};

export type LiveFormMarketMovers = {
  readonly __typename?: 'LiveFormMarketMovers';
  /** resulted rides for the meeting consisting of market movers. */
  readonly raceCount: Scalars['Int'];
  /** percentage of races won by the market movers during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the market movers during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormTopDriver = {
  readonly __typename?: 'LiveFormTopDriver';
  /** global driver ID. */
  readonly id: Scalars['ID'];
  /** Is the driver considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** driver's name. */
  readonly name: Scalars['String'];
  /** driver’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** driver’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won by the driver during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the driver during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormTopDriverNew = {
  readonly __typename?: 'LiveFormTopDriverNew';
  /** global driver ID. */
  readonly id: Scalars['ID'];
  /** Is the driver considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** driver's name. */
  readonly name: Scalars['String'];
  /** driver’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** driver’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won by the driver during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the driver during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};


export type LiveFormTopDriverNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormTopJockey = {
  readonly __typename?: 'LiveFormTopJockey';
  /** global jockey ID. */
  readonly id: Scalars['ID'];
  /** Is the jockey considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** jockey's name. */
  readonly name: Scalars['String'];
  /** jockey’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** jockey’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won by the jockey during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the jockey during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormTopJockeyNew = {
  readonly __typename?: 'LiveFormTopJockeyNew';
  /** global jockey ID. */
  readonly id: Scalars['ID'];
  /** Is the jockey considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** jockey's name. */
  readonly name: Scalars['String'];
  /** jockey’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** jockey’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won by the jockey during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the jockey during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};


export type LiveFormTopJockeyNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormTopTrainer = {
  readonly __typename?: 'LiveFormTopTrainer';
  /** global trainer ID. */
  readonly id: Scalars['ID'];
  /** Is the trainer considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** trainer's name. */
  readonly name: Scalars['String'];
  /** trainer’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** trainer’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<LiveFormUpcomingRace>>;
  /** percentage of races won by the trainer during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the trainer during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};

export type LiveFormTopTrainerNew = {
  readonly __typename?: 'LiveFormTopTrainerNew';
  /** global trainer ID. */
  readonly id: Scalars['ID'];
  /** Is the trainer considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** trainer's name. */
  readonly name: Scalars['String'];
  /** trainer’s resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** trainer’s remaining riding commitments for the meeting. */
  readonly upcomingRaces?: Maybe<ReadonlyArray<Race>>;
  /** percentage of races won by the trainer during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won by the trainer during this meeting. */
  readonly winCount: Scalars['Int'];
  /** win streak */
  readonly winStreak: Scalars['Int'];
};


export type LiveFormTopTrainerNewUpcomingRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type LiveFormTrackBias = {
  readonly __typename?: 'LiveFormTrackBias';
  /** Is the pace considered to be on a hot streak? */
  readonly isHot: Scalars['Boolean'];
  /** settlement pace on the track during this meeting */
  readonly paceCategory: PaceCategory;
  /** resulted rides for the meeting. */
  readonly raceCount: Scalars['Int'];
  /** percentage of races won from this pace during this meeting. */
  readonly value: Scalars['Float'];
  /** number of races won from this pace during this meeting. */
  readonly winCount: Scalars['Int'];
};

/** Provides a brief summary of a competitor in an upcoming race, relevant to a live form statistic. */
export type LiveFormUpcomingCompetitor = {
  readonly __typename?: 'LiveFormUpcomingCompetitor';
  /** The name of the competitor. */
  readonly name: Scalars['String'];
  /** The runner number of the competitor. */
  readonly tabNo: Scalars['Int'];
};

/** Represents a single upcoming race that is relevant to a live form statistic (e.g., a future ride for a top jockey). */
export type LiveFormUpcomingRace = {
  readonly __typename?: 'LiveFormUpcomingRace';
  /** A list of competitors in this upcoming race that are relevant to the statistic. */
  readonly competitors?: Maybe<ReadonlyArray<LiveFormUpcomingCompetitor>>;
  /** The unique identifier for the upcoming race. */
  readonly raceId: Scalars['ID'];
  /** The number of the upcoming race within its meeting. */
  readonly raceNo: Scalars['Int'];
};

export type LiveFormUpdated = {
  readonly __typename?: 'LiveFormUpdated';
  /** average odds of winning competitors. */
  readonly averageOdds?: Maybe<LiveFormAverageOdds>;
  /** number of races won by the favourite. */
  readonly favouritePerformance?: Maybe<LiveFormFavouritePerformance>;
  /** % of winners that have come from the gates. */
  readonly gateRangePerformance?: Maybe<ReadonlyArray<LiveFormGateRangePerformance>>;
  /** Meeting ID. */
  readonly id: Scalars['ID'];
  /** number of races won by the market movers. */
  readonly marketMovers?: Maybe<LiveFormMarketMovers>;
  /** % of driver that have the most wins. Only HARNESS. */
  readonly topDrivers?: Maybe<ReadonlyArray<LiveFormTopDriver>>;
  /** % of gates that have the most wins. Only THOROUGHBREDS and GREYHOUNDS. */
  readonly topGates?: Maybe<ReadonlyArray<LiveFormGatePerformance>>;
  /** % of jockey that have the most wins. Only THOROUGHBREDS. */
  readonly topJockeys?: Maybe<ReadonlyArray<LiveFormTopJockey>>;
  /** % of trainers that have the most wins. */
  readonly topTrainers?: Maybe<ReadonlyArray<LiveFormTopTrainer>>;
  /** % of winner that have come from settling track position */
  readonly trackBias?: Maybe<ReadonlyArray<LiveFormTrackBias>>;
};

/** Represents a single race meeting event, held at a specific track on a given date. */
export type Meeting = {
  readonly __typename?: 'Meeting';
  /** The advanced track condition, often provided before the official track rating. */
  readonly advancedGoing: Scalars['String'];
  /** The timestamp when the meeting was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** The official date of the meeting in UTC. */
  readonly date: Scalars['TimeStamp'];
  /** A list of external identifiers for this meeting from various data sources. Can be filtered by source. */
  readonly externalIDs?: Maybe<ReadonlyArray<Maybe<SourceId>>>;
  /** The scheduled start time of the first race of the meeting. */
  readonly firstRaceTime: Scalars['TimeStamp'];
  /** Live form and stats as the meeting progresses. This data has permissions and may incur additional charges. Please speak to our representative if you are interested. */
  readonly form?: Maybe<LiveForm>;
  /** A flag indicating if there is vision (video) coverage available for the meeting. */
  readonly hasVision: Scalars['Boolean'];
  /** The unique internal identifier for the meeting. */
  readonly id: Scalars['ID'];
  /** Returns multi-leg exotic bet types for this meeting. Can be filtered by bet type and source. */
  readonly multiLegExotics: ReadonlyArray<Exotic>;
  /** A list of races for this meeting. Can be filtered by a specific race number. */
  readonly races: ReadonlyArray<Race>;
  /** The position of the rail on the track for this meeting. */
  readonly railPosition: Scalars['String'];
  /** To indicate if the meeting is covered by TAB. */
  readonly tabIndicator: Scalars['String'];
  /** The track where the meeting is being held. */
  readonly track: Track;
  /** The type of racing. */
  readonly type: MeetingType;
  /** The timestamp of the last update to the meeting's information. */
  readonly updated: Scalars['TimeStamp'];
};


/** Represents a single race meeting event, held at a specific track on a given date. */
export type MeetingExternalIDsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents a single race meeting event, held at a specific track on a given date. */
export type MeetingMultiLegExoticsArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  type?: InputMaybe<BetType>;
};


/** Represents a single race meeting event, held at a specific track on a given date. */
export type MeetingRacesArgs = {
  raceNumber?: InputMaybe<Scalars['Int']>;
};

export enum MeetingType {
  Greyhound = 'GREYHOUND',
  Harness = 'HARNESS',
  Thoroughbred = 'THOROUGHBRED'
}

/** Contains a payload of real-time updates for a specific meeting. */
export type MeetingUpdate = {
  readonly __typename?: 'MeetingUpdate';
  /** The timestamp when the meeting was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** The official date and time of the meeting. */
  readonly date: Scalars['TimeStamp'];
  /** An updated list of external identifiers for this meeting from various data sources. */
  readonly externalIDs?: Maybe<ReadonlyArray<Maybe<SourceId>>>;
  /** The id identifier for the meeting. */
  readonly id: Scalars['ID'];
  /** To indicate if the meeting is covered by TAB. */
  readonly tabIndicator: Scalars['String'];
  /** A payload of updated information for the track where the meeting is held. */
  readonly track: TrackUpdate;
  /** The type of racing for the meeting (e.g., THOROUGHBRED, HARNESS, GREYHOUND). */
  readonly type: MeetingType;
  /** The timestamp of this specific update. */
  readonly updated: Scalars['TimeStamp'];
};


/** Contains a payload of real-time updates for a specific meeting. */
export type MeetingUpdateExternalIDsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};

export enum PaceCategory {
  Backmarker = 'BACKMARKER',
  LeadOnPace = 'LEAD_ON_PACE',
  OffPaceMidfield = 'OFF_PACE_MIDFIELD',
  Unknown = 'UNKNOWN'
}

export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly endCursor: Scalars['ID'];
  readonly hasNextPage: Scalars['Boolean'];
  readonly startCursor: Scalars['ID'];
};

export type Performance = {
  readonly __typename?: 'Performance';
  readonly a2eCareer: Scalars['Float'];
  readonly a2eLast100: Scalars['Float'];
  readonly classChange: Scalars['Float'];
  readonly conditionBenchMark: Scalars['Float'];
  readonly distanceBenchMark: Scalars['Float'];
  readonly last2YearsBenchMark: Scalars['Float'];
  readonly last200ConditionBenchMark: Scalars['Float'];
  readonly last200DistanceBenchMark: Scalars['Float'];
  readonly last200Last2YearsBenchMark: Scalars['Float'];
  readonly last200LastStartBenchMark: Scalars['Float'];
  readonly last200PrepStartBenchMark: Scalars['Float'];
  readonly last600ConditionBenchMark: Scalars['Float'];
  readonly last600DistanceBenchMark: Scalars['Float'];
  readonly last600Last2YearsBenchMark: Scalars['Float'];
  readonly last600LastStartBenchMark: Scalars['Float'];
  readonly last600PrepStartBenchMark: Scalars['Float'];
  readonly lastStartBenchMark: Scalars['Float'];
  readonly mapA2E: Scalars['Float'];
  readonly potCareer: Scalars['Float'];
  readonly potLast100: Scalars['Float'];
  readonly prepStartBenchMark: Scalars['Float'];
  readonly settle: Scalars['Int'];
  readonly speed: Scalars['Int'];
  readonly wsrCareer: Scalars['Float'];
  readonly wsrLast100: Scalars['Float'];
};

/** Represents a single, named performance rating for a competitor/race from a specific data source. */
export type PerformanceRating = {
  readonly __typename?: 'PerformanceRating';
  /** The name of the performance rating metric. */
  readonly Name: Scalars['String'];
  /** The data provider that supplied this rating. */
  readonly Source: Scalars['String'];
  /** The category or type of the rating. */
  readonly Type: Scalars['String'];
  /** The value of the rating. */
  readonly Value: Scalars['Float'];
};

/** A container for proprietary performance metrics for the runner, jockey, and trainer. */
export type Performances = {
  readonly __typename?: 'Performances';
  /** Performance metrics for the jockey. */
  readonly jockey?: Maybe<Performance>;
  /** Performance metrics for the runner. */
  readonly runner?: Maybe<Performance>;
  /** Performance metrics for the trainer. */
  readonly trainer?: Maybe<Performance>;
  /** Performance metrics for the specific trainer-jockey combination. */
  readonly trainerJockey?: Maybe<Performance>;
};

/** A base object containing a standard set of performance and placing statistics. */
export type PlacingStats = {
  readonly __typename?: 'PlacingStats';
  /** The average starting price. */
  readonly averagePrice?: Maybe<Scalars['Float']>;
  /** The average prize money won per run. */
  readonly averagePrizeMoneyWon?: Maybe<Scalars['Float']>;
  /** The average time taken to run, in seconds. */
  readonly averageTimeSeconds?: Maybe<Scalars['Float']>;
  /** The best mile rate achieved, in seconds. */
  readonly bestMileRateSeconds: Scalars['Float'];
  /** The best time achieved, in seconds. */
  readonly bestTimeSeconds: Scalars['Float'];
  /** The largest single prize money amount won. */
  readonly biggestPrizeMoneyWon?: Maybe<Scalars['Float']>;
  /** The total number of 1st place finishes. */
  readonly firsts?: Maybe<Scalars['Int']>;
  /** The time from the most recent run, in seconds. */
  readonly lastTimeSeconds: Scalars['Float'];
  /** The total number of runs included in this statistic. */
  readonly numberOfRuns?: Maybe<Scalars['Int']>;
  /** The percentage of runs that resulted in a top-3 finish. */
  readonly placePercentage?: Maybe<Scalars['Int']>;
  /** A performance rating score. */
  readonly rating: Scalars['Float'];
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly returnOnInvestment?: Maybe<ReturnOnInvestment>;
  /** The average starting price, rounded. */
  readonly roundedAveragePrice?: Maybe<Scalars['Float']>;
  /** The average prize money won, rounded. */
  readonly roundedAveragePrizeMoneyWon?: Maybe<Scalars['Float']>;
  /** The total number of 2nd place finishes. */
  readonly seconds?: Maybe<Scalars['Int']>;
  /** The total number of 3rd place finishes. */
  readonly thirds?: Maybe<Scalars['Int']>;
  /** The percentage of runs that resulted in a top-2 finish. */
  readonly top2Percentage: Scalars['Int'];
  /** The percentage of runs that resulted in a top-3 finish. */
  readonly top3Percentage: Scalars['Int'];
  /** The percentage of runs that resulted in a top-4 finish. */
  readonly top4Percentage: Scalars['Int'];
  /** The total prize money won. */
  readonly totalPrizeMoneyWon?: Maybe<Scalars['Float']>;
  /** The win percentage (firsts / numberOfRuns). */
  readonly winPercentage?: Maybe<Scalars['Int']>;
};

export enum PlatformType {
  PlatformTypeFixed = 'PLATFORM_TYPE_FIXED',
  PlatformTypeTote = 'PLATFORM_TYPE_TOTE',
  PlatformTypeUnknown = 'PLATFORM_TYPE_UNKNOWN'
}

/** Provides detailed positional data for a competitor at a specific point of call during a race. */
export type PointOfCall = {
  readonly __typename?: 'PointOfCall';
  /** The margin in lengths this competitor was ahead of the next horse. */
  readonly lengthsAhead: Scalars['Int'];
  /** The margin in lengths this competitor was behind the horse in front. */
  readonly lengthsBehind: Scalars['Int'];
  /** A code identifying the point of call. */
  readonly pointOfCallId: Scalars['String'];
  /** A human-readable description of the point of call. */
  readonly pointOfCallPrint: Scalars['String'];
  /** The competitor's running position at this point. */
  readonly position: Scalars['Int'];
};

/** A real-time update payload for changes to a race's pre-jump status. */
export type PreJumpRaceStatusUpdate = {
  readonly __typename?: 'PreJumpRaceStatusUpdate';
  /** The id of the race being updated. */
  readonly id: Scalars['ID'];
  /** The id of the meeting this race belongs to. */
  readonly meetingId: Scalars['ID'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The pre-jump status. */
  readonly status: PreJumpStatus;
  /** The timestamp when this pre-jump status update occurred. */
  readonly updated: Scalars['TimeStamp'];
};

export enum PreJumpStatus {
  /** The runners have arrived at the starting area and are positioned behind the barriers, waiting to be loaded into the starting gates */
  BehindTheGate = 'BEHIND_THE_GATE',
  /** The jump had been delayed */
  Delay = 'DELAY',
  /** The first runner has been loaded into the starting gates */
  FirstHorseIn = 'FIRST_HORSE_IN',
  /** There are 5 runners remaining to be loaded into the starting gates */
  FiveHorseIn = 'FIVE_HORSE_IN',
  /** The runners have started moving behind the starting gate */
  GoingBehind = 'GOING_BEHIND',
  /** The runners have left the mounting yard (or parade ring) and are head down to the starting gates */
  GoingDown = 'GOING_DOWN',
  /** The final runner has entered the starting gate */
  LastHorseIn = 'LAST_HORSE_IN',
  /** A runner has been scratched at the starting gate */
  LateScratched = 'LATE_SCRATCHED',
  /** There is 1 runner remaining to be loaded into the starting gates */
  OneToGo = 'ONE_TO_GO',
  /** The race has jumped */
  RaceJumped = 'RACE_JUMPED',
  /** There are 7 runners remaining to be loaded into the starting gates */
  SevenHorseIn = 'SEVEN_HORSE_IN',
  /** There are 6 runners remaining to be loaded into the starting gates */
  SixHorseIn = 'SIX_HORSE_IN',
  /** There are 3 runners remaining to be loaded into the starting gates */
  ThreeToGo = 'THREE_TO_GO',
  /** There are 2 runners remaining to be loaded into the starting gates */
  TwoToGo = 'TWO_TO_GO',
  /** Contact our commercial team for access */
  Unauthorised = 'UNAUTHORISED',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export type PredictedRating = {
  readonly __typename?: 'PredictedRating';
  readonly allPreviousRatings: Scalars['String'];
  readonly averageMargin: Scalars['Float'];
  readonly careerBestRating: Scalars['Float'];
  readonly lastStartRating: Scalars['Float'];
  readonly morningLine: Scalars['Float'];
  readonly predictedPrice: Scalars['Float'];
  readonly predictedPriceHundredThirty: Scalars['Float'];
  readonly predictedRating: Scalars['Float'];
  readonly raceAdjustedRating: Scalars['Float'];
  readonly raceExpectedSpeed: Scalars['Float'];
  readonly raceRating: Scalars['Float'];
  readonly raceRawRating: Scalars['Float'];
  readonly raceRawRatingAvg: Scalars['Float'];
  readonly raceStandardTime: Scalars['Float'];
  readonly raceTrackVariant: Scalars['Float'];
  readonly ratingHorseId: Scalars['Int'];
  readonly secondLastStartRating: Scalars['Float'];
  readonly standardDeviation: Scalars['Float'];
  readonly tabNo: Scalars['Int'];
  readonly thirdLastStartRating: Scalars['Float'];
};

export type PredictedRatingUpdate = {
  readonly __typename?: 'PredictedRatingUpdate';
  readonly allPreviousRatings: Scalars['String'];
  readonly averageMargin: Scalars['Float'];
  readonly careerBestRating: Scalars['Float'];
  readonly lastStartRating: Scalars['Float'];
  readonly morningLine: Scalars['Float'];
  readonly predictedPrice: Scalars['Float'];
  readonly predictedPriceHundredThirty: Scalars['Float'];
  readonly predictedRating: Scalars['Float'];
  readonly raceAdjustedRating: Scalars['Float'];
  readonly raceExpectedSpeed: Scalars['Float'];
  readonly raceID: Scalars['String'];
  readonly raceRating: Scalars['Float'];
  readonly raceRawRating: Scalars['Float'];
  readonly raceRawRatingAvg: Scalars['Float'];
  readonly raceStandardTime: Scalars['Float'];
  readonly raceTrackVariant: Scalars['Float'];
  readonly ratingHorseId: Scalars['Int'];
  readonly secondLastStartRating: Scalars['Float'];
  readonly standardDeviation: Scalars['Float'];
  readonly tabNo: Scalars['Int'];
  readonly thirdLastStartRating: Scalars['Float'];
};

/** Represents the odds for a single competitor in a specific market (e.g., the Win price for horse #5). */
export type Price = {
  readonly __typename?: 'Price';
  /** A user-friendly string representation of the price at 2 decimal places. */
  readonly displayPrice: Scalars['String'];
  /** Normalised Price. */
  readonly normalisedPrice: Scalars['Float'];
  /** The raw decimal value of the odds. */
  readonly price: Scalars['Float'];
  /** The data provider that is offering this price. */
  readonly source: Scalars['String'];
  /** The runner number of the competitor this price applies to. */
  readonly tabNo: Scalars['Int'];
  /** The type of market this price belongs to (e.g., WIN, PLACE_FIXED_ODDS). */
  readonly type: PriceType;
  /** The timestamp when this specific price was last updated. */
  readonly updated?: Maybe<Scalars['TimeStamp']>;
};

/** Represents a single price fluctuation for a competitor, capturing a snapshot of their odds at a specific time. */
export type PriceFluc = {
  readonly __typename?: 'PriceFluc';
  /** The new decimal odds for the competitor at the recorded time. */
  readonly price: Scalars['Float'];
  /** The runner number of the competitor whose price has fluctuated. */
  readonly tabNo: Scalars['Int'];
  /** The exact time at which the price fluctuation was recorded. */
  readonly time: Scalars['TimeStamp'];
};

/** Represents a set of prices for a specific market type (e.g., Win, Place) from a single data source for a given race. */
export type PriceSet = {
  readonly __typename?: 'PriceSet';
  /** The unique event identifier for a price associated with a futures event. */
  readonly futuresEventId: Scalars['String'];
  /** Market Overround. */
  readonly marketOverround: Scalars['Float'];
  /** The unique identifier for the meeting this price set belongs to. */
  readonly meetingID: Scalars['String'];
  /** The total amount of money in the betting pool for this market type, if applicable. */
  readonly poolSize: Scalars['Int'];
  /** A list of the individual prices for each competitor in this market. */
  readonly prices: ReadonlyArray<Price>;
  /** The unique identifier for the race this price set belongs to. */
  readonly raceId: Scalars['String'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The data provider for this set of prices (e.g., a specific tote or bookmaker). */
  readonly source: Scalars['String'];
  /** Indicates if the market is currently suspended. For generated prices, 'Suspend Pricing On Insufficient Weighting' needs to be enabled on your PM account. */
  readonly suspendedPrice: Scalars['Boolean'];
  /** The type of market this price set represents (e.g., WIN, PLACE_FIXED_ODDS). */
  readonly type: PriceType;
  /** The timestamp of the last update to this price set. */
  readonly updated: Scalars['TimeStamp'];
};

export enum PriceType {
  MorningLineWin = 'MORNING_LINE_WIN',
  Place = 'PLACE',
  Place_2 = 'PLACE_2',
  PlaceFixedOdds = 'PLACE_FIXED_ODDS',
  PlaceFixedOdds2 = 'PLACE_FIXED_ODDS2',
  Win = 'WIN',
  WinFixedOdds = 'WIN_FIXED_ODDS'
}

/** Represents the prizes associated to this race. */
export type Prizes = {
  readonly __typename?: 'Prizes';
  /** The finishing position this prize money is for (e.g., '1st', '2nd'). */
  readonly type: Scalars['String'];
  /** The prize money amount awarded for this prize. */
  readonly value: Scalars['Float'];
};

export type ProInsight = {
  readonly __typename?: 'ProInsight';
  /** Insight's grouping. */
  readonly category: Scalars['String'];
  /** Insight's comment. */
  readonly comment: Scalars['String'];
  /** Betmakers' priority of importance in the UI. */
  readonly displayOrder: Scalars['Int'];
  /** Insight's key. */
  readonly key: Scalars['String'];
  /** Insight's name. */
  readonly name: Scalars['String'];
  /** Insight's runner number. */
  readonly runnerNumber: Scalars['Int'];
  /** Insight's Sentiment. E.g.,: positive or negative. */
  readonly sentiment: Scalars['String'];
};

export type Query = {
  readonly __typename?: 'Query';
  /** Returns a single, specific futures event by its unique ID. */
  readonly futureEvent: FuturesV2Event;
  /** Returns future racing events. Use the optional `range` argument to get events scheduled between the 'from' and 'to' dates. If the range is omitted, all future events will be returned. */
  readonly futureEvents: ReadonlyArray<FuturesV2Event>;
  /** Returns futures markets for major upcoming events within a specified date range. Note: This is a legacy futures query; for new integrations, please use `futureEvents`. */
  readonly futures: Futures;
  /** Returns a single meeting and all its associated race data. You must provide either the unique internal `id` or an `externalID` (which combines a `source` and the `sourceId` from that provider). */
  readonly meeting?: Maybe<Meeting>;
  /** Returns a list of meetings. Use `date` for a single day's meetings (format: `YYYY-MM-DDT00:00:00Z` - Time always set to zero.), or `firstRaceFrom` and `to` for meetings where the first race is within that specific time range. The `to` date can be at most 5 days after the `from` date. */
  readonly meetingsDated: ReadonlyArray<Meeting>;
  /** Returns multi-race exotic bet types (e.g. Quaddies, Pick4, etc) for a given date or date range. Can be filtered by bet `type`, data `sources`, and optionally constrained to only those exotics that span multiple meetings. */
  readonly multiLegExoticsDated: ReadonlyArray<Exotic>;
  /** Returns a single race and all its details, including competitors. You must provide either the unique internal `id` or an `externalID` (which combines a `source` and the `sourceId` from that provider). */
  readonly race?: Maybe<Race>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly raceJockey?: Maybe<RaceJockey>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly raceRunner?: Maybe<RaceRunner>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly raceTrainer?: Maybe<RaceTrainer>;
  /** Returns a list of races. A `from` start time is mandatory. The results can be filtered to `include` or `exclude` specific criteria (like `MeetingType` or `Country`) and the total number of returned races can be capped using `limit`. Default `limit` is set to 10. */
  readonly races: ReadonlyArray<Race>;
  readonly resolveRacelabInsightsUpdated: RacelabInsightsUpdated;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly runner?: Maybe<Runner>;
  /** Returns the form history for a runner by their global runner ID. */
  readonly runnerFormHistory: ReadonlyArray<Maybe<RunnerForm>>;
  /** Returns the statistics for a runner by their global runner ID. */
  readonly runnerStats?: Maybe<Statistics>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly searchRaceJockeys: ReadonlyArray<Maybe<JockeyResult>>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly searchRaceRunners: ReadonlyArray<Maybe<RunnerResult>>;
  /**
   * Deprecated.
   * @deprecated No longer supported
   */
  readonly searchRaceTrainers: ReadonlyArray<Maybe<TrainerResult>>;
  /** Returns the list of data providers available based on your account's permissions. Optionally, filter for a single provider by passing its code. */
  readonly sources: ReadonlyArray<Source>;
  /** Returns a single track by its unique `id`. */
  readonly track?: Maybe<Track>;
  /** Returns a complete list of all available racing tracks (venues) in the system. */
  readonly tracks?: Maybe<ReadonlyArray<Track>>;
  /** Returns the results and dividends for a single completed virtual race, identified by its `race_id`. */
  readonly virtualRaceResult: VirtualRaceResult;
  /** Returns available betting selections and odds for a virtual race. Requires the `race_id` and can be filtered by the desired `betTypes`. */
  readonly virtualRaceSelection: VirtualSelections;
  /** Returns details for virtual races from a specific `source`, optionally filtering by a list of `ids`. */
  readonly virtualRaces: ReadonlyArray<VirtualRace>;
};


export type QueryFutureEventArgs = {
  id: Scalars['ID'];
};


export type QueryFutureEventsArgs = {
  range?: InputMaybe<DateRange>;
};


export type QueryFuturesArgs = {
  endDate?: InputMaybe<Scalars['Time']>;
  serverTimestamp?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Time']>;
};


export type QueryMeetingArgs = {
  externalID?: InputMaybe<InputSourceId>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMeetingsDatedArgs = {
  date?: InputMaybe<Scalars['Time']>;
  firstRaceFrom?: InputMaybe<Scalars['Time']>;
  to?: InputMaybe<Scalars['Time']>;
};


export type QueryMultiLegExoticsDatedArgs = {
  date?: InputMaybe<Scalars['Time']>;
  firstRaceFrom?: InputMaybe<Scalars['Time']>;
  onlyIncludeCrossMeetings?: InputMaybe<Scalars['Boolean']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  to?: InputMaybe<Scalars['Time']>;
  type?: InputMaybe<BetType>;
};


export type QueryRaceArgs = {
  externalID?: InputMaybe<InputSourceRaceId>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRaceJockeyArgs = {
  formHistoryLimit?: InputMaybe<Scalars['Int']>;
  formHistoryStart?: InputMaybe<Scalars['Int']>;
  globalId?: InputMaybe<Scalars['ID']>;
};


export type QueryRaceRunnerArgs = {
  formHistoryLimit?: InputMaybe<Scalars['Int']>;
  formHistoryStart?: InputMaybe<Scalars['Int']>;
  globalId?: InputMaybe<Scalars['ID']>;
};


export type QueryRaceTrainerArgs = {
  formHistoryLimit?: InputMaybe<Scalars['Int']>;
  formHistoryStart?: InputMaybe<Scalars['Int']>;
  globalId?: InputMaybe<Scalars['ID']>;
};


export type QueryRacesArgs = {
  exclude?: InputMaybe<ReadonlyArray<InputMaybe<Filter>>>;
  from: Scalars['Time'];
  include?: InputMaybe<ReadonlyArray<InputMaybe<Filter>>>;
  limit?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Time']>;
};


export type QueryRunnerArgs = {
  id: Scalars['ID'];
};


export type QueryRunnerFormHistoryArgs = {
  globalId: Scalars['ID'];
  maxRuns?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryRunnerStatsArgs = {
  globalId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
};


export type QuerySearchRaceJockeysArgs = {
  jockeyName?: InputMaybe<Scalars['String']>;
  meetingType?: InputMaybe<Scalars['String']>;
  pageLimit?: InputMaybe<Scalars['Int']>;
  pageStart?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchRaceRunnersArgs = {
  countryOfBirth?: InputMaybe<Scalars['String']>;
  damName?: InputMaybe<Scalars['String']>;
  maxDob?: InputMaybe<Scalars['String']>;
  meetingType?: InputMaybe<Scalars['String']>;
  minDob?: InputMaybe<Scalars['String']>;
  pageLimit?: InputMaybe<Scalars['Int']>;
  pageStart?: InputMaybe<Scalars['Int']>;
  runnerName?: InputMaybe<Scalars['String']>;
  sireName?: InputMaybe<Scalars['String']>;
};


export type QuerySearchRaceTrainersArgs = {
  meetingType?: InputMaybe<Scalars['String']>;
  pageLimit?: InputMaybe<Scalars['Int']>;
  pageStart?: InputMaybe<Scalars['Int']>;
  trainerName?: InputMaybe<Scalars['String']>;
};


export type QuerySourcesArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type QueryTrackArgs = {
  id: Scalars['ID'];
};


export type QueryVirtualRaceResultArgs = {
  race_id: Scalars['String'];
};


export type QueryVirtualRaceSelectionArgs = {
  betTypes?: InputMaybe<ReadonlyArray<VirtualBetType>>;
  race_id: Scalars['String'];
};


export type QueryVirtualRacesArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  source?: InputMaybe<Scalars['String']>;
};

export type QuickInsight = {
  readonly __typename?: 'QuickInsight';
  /** Betmakers' priority of importance in the UI. */
  readonly displayOrder: Scalars['Int'];
  /** Insight's key. */
  readonly key: Scalars['String'];
  /** Insight's name. */
  readonly name: Scalars['String'];
  /** Insight's percentage. */
  readonly percentage: Scalars['Int'];
  /** Insight's runner number. */
  readonly runnerNumber: Scalars['Int'];
  /** Insight's value. */
  readonly value: Scalars['Float'];
};

export type RacelabInsights = {
  readonly __typename?: 'RACELABInsights';
  readonly pro?: Maybe<ReadonlyArray<ProInsight>>;
  readonly quick?: Maybe<ReadonlyArray<QuickInsight>>;
};

export type RacelabInsightsUpdated = {
  readonly __typename?: 'RACELABInsightsUpdated';
  /** Pro insights. */
  readonly pro?: Maybe<ReadonlyArray<ProInsight>>;
  /** Quick insights. */
  readonly quick?: Maybe<ReadonlyArray<QuickInsight>>;
  /** Race ID */
  readonly raceId: Scalars['ID'];
};

/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type Race = {
  readonly __typename?: 'Race';
  /** BetFair market information for the race. If `priceType` is not specified, it returns the win market. Requires Betfair price permission. */
  readonly betFairMarkets?: Maybe<BetFairMarket>;
  /** The class or grade of the race (e.g., Group 1, Maiden). */
  readonly class: Scalars['String'];
  /** @deprecated comment is deprecated, use `comments(source)` instead */
  readonly comment: Scalars['String'];
  /** Analyst comments and tips for the race, filterable by language and source. Permissions required for additional languages. */
  readonly comments: ReadonlyArray<SourceComment>;
  /** A list of competitors in the race. Can be filtered by a specific runner number. */
  readonly competitors: ReadonlyArray<Competitor>;
  /** URL for the course map image. This data may require special permissions and incur additional charges. Please contact us for more information. */
  readonly courseMapURL: Scalars['String'];
  /** The timestamp when the race was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /** Deduction information for the race, typically for regulated markets like Victorian Thoroughbreds. Can be filtered by `source` and option to include emergencies. */
  readonly deductionSet: ReadonlyArray<DeductionSet>;
  /** The timestamp for the original start time of the race. */
  readonly displayTime: Scalars['TimeStamp'];
  /**
   * The distance of the race, standardized to meters. This value is calculated from various source units (e.g., Furlongs, Yards, Kilometers) and rounded to the nearest integer. Data is not always consistent, we try our best to ensure it's in meters.
   *
   * METERS: value
   * FURLONGS: value * 201.168
   * KILOMETERS: value * 1000
   * MILES: value * 1609.34
   * YARDS: value * 0.9144
   * FEET: value * 0.3048
   */
  readonly distance: Scalars['Int'];
  /** The official time duration of the race from start to finish. */
  readonly duration: Scalars['String'];
  /** The number of places paid for each-way bets. */
  readonly eachWayPlaces: Scalars['Int'];
  /** The reduction factor applied to each-way bets. */
  readonly eachWayReduction: Scalars['Int'];
  /** Exotic betting products available for this race, such as Trifecta or Quinella. Can be filtered by bet type and source. */
  readonly exotics: ReadonlyArray<Exotic>;
  /** The race's identifier from a specific external data source. */
  readonly externalId: Scalars['String'];
  /** Indicates if fixed odds betting is available for this race. */
  readonly fixedAvailable: Scalars['Boolean'];
  /** Indicates if Forecast betting is available for this race. */
  readonly forecast: Scalars['Boolean'];
  /** The gait of the race, primarily for Harness racing (Gallop, Pace, Trot). */
  readonly gait: Scalars['String'];
  /** The generated derivative markets for the race, filterable by source. */
  readonly generatedDerivatives: ReadonlyArray<Derivative>;
  /** The generated exotics for the race. */
  readonly generatedExotics: ReadonlyArray<GeneratedExotic>;
  /** Indicates if the race is a handicap race. */
  readonly handicap: Scalars['Boolean'];
  /** The start type for Harness races (e.g., Standing, Mobile). */
  readonly harnessStartType?: Maybe<HarnessStartType>;
  /** Indicates if speedmaps are available for this race. */
  readonly hasSpeedmaps: Scalars['Boolean'];
  /** The unique internal identifier for the race. */
  readonly id: Scalars['ID'];
  /** In-Run Price Sources covering the race. */
  readonly inRunPriceSources: ReadonlyArray<Scalars['String']>;
  /** The official jump time of the race in UTC. */
  readonly jumpTime?: Maybe<Scalars['TimeStamp']>;
  /** The meeting this race belongs to. */
  readonly meeting: Meeting;
  /** The official name of the race. */
  readonly name: Scalars['String'];
  /** The race number within the meeting. */
  readonly number: Scalars['Int'];
  /** The number of paid places for the race. */
  readonly numberOfPlaces: Scalars['Int'];
  /** Historical pool data, implemented only on Tote Win/Place markets. Price source permission is required. */
  readonly poolHistory: ReadonlyArray<PriceSet>;
  /** Information about tote pools for the race, filterable by source. */
  readonly pools?: Maybe<ReadonlyArray<RacePool>>;
  /** The status of the race just before the jump (e.g., GOING_BEHIND, LAST_HORSE_IN). */
  readonly preJumpStatus: PreJumpStatus;
  /** A list of price sets (e.g., Win, Place) for the race, filterable by source. */
  readonly priceSets: ReadonlyArray<PriceSet>;
  /** The total prize money for the race. */
  readonly prizeMoney: Scalars['Int'];
  /** A breakdown of the prize money distribution for each finishing position. */
  readonly prizes: ReadonlyArray<Prizes>;
  /** Internal ratings. Not available for external use. */
  readonly ratings: ReadonlyArray<PerformanceRating>;
  /** Details on the restrictions for competitors in the race (e.g., age, sex). */
  readonly restrictions: Restrictions;
  /** The official results for the race. Can be filtered by source and can optionally include interim results. */
  readonly results: ReadonlyArray<ResultSet>;
  /** Rule 4 deduction information, typically for UK races. Can be filtered by source and deduction type. */
  readonly rule4: ReadonlyArray<Rule4>;
  /** Sectional times for the race. */
  readonly sectionals: ReadonlyArray<RaceSectional>;
  /** The types of selections available for the race. */
  readonly selections: ReadonlyArray<RaceSelectionType>;
  /** The Sky Racing channel number broadcasting the race. Permission required. */
  readonly skyChannel: Scalars['Int'];
  /** Speedmap data for the race, filterable by source. */
  readonly speedMaps: ReadonlyArray<RaceSpeedMap>;
  /** Only for Same Race Multi clients. Lists the prices for the market, including win and top 2/3/4 prices for a given market and customer. */
  readonly srmListPrices: ReadonlyArray<SrmListPrice>;
  /**
   * Only for Same Race Multi clients. Calculates the price for a set of SRM selections.
   * - `maxPrice` defaults to 10001 if not provided. The calculated price will be capped at this value.
   * - `legs`: Each selection must include all relevant positions (e.g., for 'Top 3', pass `positions: [1, 2, 3]`).
   * - `margin` should be a value over 100.
   */
  readonly srmPriceSelections: SrmSelectionPrice;
  /** The scheduled start time of the race. */
  readonly startTime: Scalars['TimeStamp'];
  /** The number of official starters in the race. */
  readonly starters: Scalars['Int'];
  /** The current status of the race (e.g., OPEN, FINAL, ABANDONED). */
  readonly status: RaceStatus;
  /** The type of surface the race is run on (e.g., Turf, Synthetic). */
  readonly surfaceType: Scalars['String'];
  /** Tote products available for this race. This query is only available for TOTE terminals. */
  readonly toteProducts: ReadonlyArray<ToteProduct>;
  /** The official condition of the track for this race (e.g., GOOD4, HEAVY8). */
  readonly trackCondition: TrackCondition;
  /** Indicates if Tricast betting is available for this race. */
  readonly tricast: Scalars['Boolean'];
  /** The timestamp of the last update to the race's information. */
  readonly updated: Scalars['TimeStamp'];
  /** The weather conditions at the track for this race. */
  readonly weather: Scalars['String'];
  /** The weight type for the race (e.g. HANDICAP, SET WEIGHT, SET WEIGHT WITH ALLOWANCE, CATCH WEIGHT). Appears for AUS races, will only be set if it's a handicap race. */
  readonly weightType: Scalars['String'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceBetFairMarketsArgs = {
  priceType?: InputMaybe<BetFairPriceType>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceCommentsArgs = {
  languages?: InputMaybe<ReadonlyArray<Language>>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceCompetitorsArgs = {
  runnerNumber?: InputMaybe<Scalars['Int']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceCourseMapUrlArgs = {
  source: Scalars['String'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceDeductionSetArgs = {
  include_emergencies?: InputMaybe<Scalars['Boolean']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceExoticsArgs = {
  return_on_all_legs?: InputMaybe<Scalars['Boolean']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  type?: InputMaybe<BetType>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceExternalIdArgs = {
  source: Scalars['String'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceGeneratedDerivativesArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RacePoolHistoryArgs = {
  priceType: PriceType;
  source: Scalars['String'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RacePoolsArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RacePriceSetsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceRatingsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceResultsArgs = {
  includeInterim?: InputMaybe<Scalars['Boolean']>;
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceRule4Args = {
  deductionType?: InputMaybe<Rule4DeductionType>;
  source?: InputMaybe<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceSpeedMapsArgs = {
  sources: ReadonlyArray<Scalars['String']>;
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceSrmPriceSelectionsArgs = {
  legs: ReadonlyArray<InputMaybe<SrmLeg>>;
  margin: Scalars['Float'];
  maxPrice: Scalars['Float'];
};


/** Represents an individual race, which is part of a meeting. It contains all details about the race itself and its participants. */
export type RaceToteProductsArgs = {
  source: Scalars['String'];
};

export type RaceJockey = {
  readonly __typename?: 'RaceJockey';
  readonly acceptances: ReadonlyArray<Maybe<Acceptance>>;
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  readonly jockeyIdentifier?: Maybe<JockeyIdentifier>;
  readonly statistics: Statistics;
};

/** Represents a tote betting pool for a specific race, providing identifiers and details required to interact with the tote system. */
export type RacePool = {
  readonly __typename?: 'RacePool';
  /** For multi-leg bets, this indicates which leg of the bet this race corresponds to. */
  readonly legNumber: Scalars['Int'];
  /** The tote provider that is hosting this betting pool. */
  readonly source: Scalars['String'];
  /** The runner number designated as the substitute for this leg if a primary selection is scratched. */
  readonly substituteRunnerNumber: Scalars['Int'];
  /** The meeting code used by the tote for this specific race meeting. */
  readonly tabCode: Scalars['String'];
  /** The official date of the race meeting. */
  readonly tabDate?: Maybe<Scalars['TimeStamp']>;
  /** The race number. */
  readonly tabRaceNumber: Scalars['Int'];
  /** The type of bet this pool is for (e.g., WIN, QUADRELLA). */
  readonly type: BetType;
};

/** A real-time notification payload for updates to substitute runners in a tote pool. */
export type RacePoolSubstituteUpdates = {
  readonly __typename?: 'RacePoolSubstituteUpdates';
  /** The unique identifier of the race being updated. */
  readonly raceId: Scalars['ID'];
  /** The runner number of the new substitute. */
  readonly runnerNumber: Scalars['Int'];
  /** The tote provider that issued the update. */
  readonly source: Scalars['String'];
  /** The specific bet type or pool that is affected. */
  readonly type: BetType;
};

/** A notification payload, that is sent when a new market for a race is priced for the first time. */
export type RacePriced = {
  readonly __typename?: 'RacePriced';
  /** The unique identifier of the meeting where the race was priced. */
  readonly meetingId: Scalars['ID'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The data provider that has supplied the initial prices. */
  readonly source: Scalars['String'];
  /** The type of market that has just been priced (e.g., WIN, PLACE). */
  readonly type: PriceType;
};

export type RaceRunner = {
  readonly __typename?: 'RaceRunner';
  readonly acceptances: ReadonlyArray<Maybe<Acceptance>>;
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  readonly runnerData?: Maybe<RunnerData>;
  readonly runnerIdentifier?: Maybe<RunnerIdentifier>;
  readonly statistics: Statistics;
};

/** Represents a sectional time, which is the time taken to run a specific section of a race. */
export type RaceSectional = {
  readonly __typename?: 'RaceSectional';
  /** The distance marker for this sectional, in meters from the finish line. */
  readonly distance: Scalars['Int'];
  /** A description of the sectional point (e.g., '800m to 400m'). */
  readonly location: Scalars['String'];
  /** The time in seconds taken to run this section of the race. */
  readonly seconds: Scalars['Float'];
};

/** Represents a set of expert tips or predictions for a race from a single data provider. */
export type RaceSelectionType = {
  readonly __typename?: 'RaceSelectionType';
  /** A comma-separated string of runner numbers representing the provider's predicted best runners or top tips in the race. */
  readonly raceSelection: Scalars['String'];
  /** The data provider that supplied these tips. */
  readonly source: Scalars['String'];
};

/** Contains speedmap data from a specific source, predicting the likely running positions of competitors in the early stages of the race. */
export type RaceSpeedMap = {
  readonly __typename?: 'RaceSpeedMap';
  /** A formatted string representing the speedmap data. The format is typically 'STAGE | RUNNER-VALUE,RUNNER-VALUE,...'. 'VALUE' is a score where a lower number generally indicates a faster early speed, predicting a position closer to the lead. The string may also contain non-numeric values for certain runners (e.g., 'SC' for scratched). */
  readonly raceSpeedMaps: Scalars['String'];
  /** The data provider that supplied the speedmap. */
  readonly source: Scalars['String'];
};

export enum RaceStatus {
  Abandoned = 'ABANDONED',
  BehindGates = 'BEHIND_GATES',
  Closed = 'CLOSED',
  Final = 'FINAL',
  Interim = 'INTERIM',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  PastPost = 'PAST_POST',
  Protest = 'PROTEST',
  Unknown = 'UNKNOWN'
}

/** Provides a real-time update for a change in a race's status */
export type RaceStatusUpdate = {
  readonly __typename?: 'RaceStatusUpdate';
  /** The id of the race whose status has been updated. */
  readonly id: Scalars['ID'];
  /** The new, current status of the race (e.g., 'CLOSED', 'FINAL', 'ABANDONED'). */
  readonly status: RaceStatus;
  /** The timestamp when this status update occurred. */
  readonly updated: Scalars['TimeStamp'];
};

export type RaceTrainer = {
  readonly __typename?: 'RaceTrainer';
  readonly acceptances: ReadonlyArray<Maybe<Acceptance>>;
  readonly formHistory: ReadonlyArray<Maybe<RunnerForm>>;
  readonly statistics: Statistics;
  readonly trainerIdentifier?: Maybe<TrainerIdentifier>;
};

/** Contains a payload of real-time updates for a specific race. */
export type RaceUpdate = {
  readonly __typename?: 'RaceUpdate';
  /** The updated class or grade of the race. */
  readonly class: Scalars['String'];
  /** A list of competitors with their latest updated information. */
  readonly competitors: ReadonlyArray<CompetitorUpdate>;
  /** The timestamp when the race was first created in the system. */
  readonly created: Scalars['TimeStamp'];
  /**
   * The distance of the race, standardized to meters. This value is calculated from various source units (e.g., Furlongs, Yards, Kilometers) and rounded to the nearest integer. Data is not always consistent, we try our best to ensure it's in meters.
   *
   * METERS: value
   * FURLONGS: value * 201.168
   * KILOMETERS: value * 1000
   * MILES: value * 1609.34
   * YARDS: value * 0.9144
   * FEET: value * 0.3048
   */
  readonly distance: Scalars['Int'];
  /** The updated number of places paid for each-way bets. */
  readonly eachWayPlaces: Scalars['Int'];
  /** The updated reduction factor applied to each-way bets. */
  readonly eachWayReduction: Scalars['Int'];
  /** Indicates if the race is a handicap race. */
  readonly handicap: Scalars['Boolean'];
  /** The ID for the race. */
  readonly id: Scalars['ID'];
  /** The updated official jump time of the race. */
  readonly jumpTime: Scalars['TimeStamp'];
  /** The updated information for the meeting this race belongs to. */
  readonly meeting: MeetingUpdate;
  /** The official name of the race. */
  readonly name: Scalars['String'];
  /** The race number within the meeting. */
  readonly number: Scalars['Int'];
  /** Updated information about the tote pools for the race. */
  readonly pools?: Maybe<ReadonlyArray<RacePool>>;
  /** The updated pre-jump status of the race (e.g., GOING_BEHIND, LAST_HORSE_IN). */
  readonly preJumpStatus: PreJumpStatus;
  /** The total prize money for the race. */
  readonly prizeMoney: Scalars['Int'];
  /** The updated Sky Racing channel number broadcasting the race. */
  readonly skyChannel: Scalars['Int'];
  /** The updated scheduled start time of the race. */
  readonly startTime: Scalars['TimeStamp'];
  /** The updated current status of the race (e.g., OPEN, FINAL, ABANDONED). */
  readonly status: RaceStatus;
  /** The updated type of surface the race is run on (e.g., Turf, Synthetic). */
  readonly surfaceType: Scalars['String'];
  /** The updated condition of the track for this race (e.g., GOOD, HEAVY). */
  readonly trackCondition: TrackCondition;
  /** The timestamp of this specific update. */
  readonly updated: Scalars['TimeStamp'];
  /** The updated weather conditions at the track. */
  readonly weather: Scalars['String'];
};

export enum RacingType {
  Future = 'FUTURE',
  Racing = 'RACING'
}

export type Rating = {
  readonly __typename?: 'Rating';
  readonly career: Scalars['Float'];
  readonly currentJockey: Scalars['Float'];
  readonly distance: Scalars['Float'];
  readonly distanceTrack: Scalars['Float'];
  readonly dry: Scalars['Float'];
  readonly firm: Scalars['Float'];
  readonly firstUp: Scalars['Float'];
  readonly fourthUp: Scalars['Float'];
  readonly good: Scalars['Float'];
  readonly group1: Scalars['Float'];
  readonly group2: Scalars['Float'];
  readonly group3: Scalars['Float'];
  readonly handicap: Scalars['Float'];
  readonly heavy: Scalars['Float'];
  readonly jumps: Scalars['Float'];
  readonly listed: Scalars['Float'];
  readonly night: Scalars['Float'];
  readonly preparation: Scalars['Float'];
  readonly price: Scalars['Float'];
  readonly secondUp: Scalars['Float'];
  readonly soft: Scalars['Float'];
  readonly synthetic: Scalars['Float'];
  readonly thirdUp: Scalars['Float'];
  readonly track: Scalars['Float'];
  readonly unadjusted: Scalars['Float'];
  readonly weightForAge: Scalars['Float'];
  readonly wet: Scalars['Float'];
};

export type Recent = {
  readonly __typename?: 'Recent';
  /**
   * A summary of the runner's last 10 starts (most recent on the right).
   *
   * Each character represents a race outcome:
   * - `x`   → The run occurred after a spell.
   * - `-`   → The run either failed to finish or the runner was disqualified.
   * - `0`   → The runner finished 10th place or worse.
   * - `1-9` → The runner's actual finishing position (1st to 9th).
   * - `?`   → The finishing position is unknown (FinishPosition is null, possible data error).
   */
  readonly last10Starts?: Maybe<Scalars['String']>;
  /** Number of times the runner finished 1st in the last 4 starts. */
  readonly numberOfFirstsInLast4?: Maybe<Scalars['Int']>;
  /** Number of times the runner finished 1st in the last 10 starts. */
  readonly numberOfFirstsInLast10?: Maybe<Scalars['Int']>;
  /** Number of times the runner finished in a placing position (2nd or 3rd) in the last 4 starts. */
  readonly numberOfPlacesInLast4?: Maybe<Scalars['Int']>;
  /** Number of times the runner finished in a placing position (2nd or 3rd) in the last 10 starts. */
  readonly numberOfPlacesInLast10?: Maybe<Scalars['Int']>;
  /** Current streak of consecutive races with a placing finish (1st, 2nd, or 3rd). */
  readonly placingStreak?: Maybe<Scalars['Int']>;
  /** Current streak of consecutive wins (1st place finishes). */
  readonly winningStreak?: Maybe<Scalars['Int']>;
};

/** When available - Describes the eligibility conditions for a race, such as age, sex, and weight restrictions for competitors. */
export type Restrictions = {
  readonly __typename?: 'Restrictions';
  /** The age restriction for the race. */
  readonly age: Scalars['String'];
  /** Any restrictions on the jockey (e.g., 'Apprentices Can Claim'). */
  readonly jockey: Scalars['String'];
  /** The sex restriction for the race (e.g., 'Males and geldings'). */
  readonly sex: Scalars['String'];
  /** The weight conditions for the race (e.g., 'Handicap', 'Set Weights'). */
  readonly weight: Scalars['String'];
};

export type ResultDeduction = {
  readonly __typename?: 'ResultDeduction';
  readonly DeductionBetType: Scalars['String'];
  readonly DeductionTime: Scalars['String'];
  readonly MarketType: Scalars['String'];
  readonly amount: Scalars['Float'];
  readonly tabNo: Scalars['String'];
  readonly type: BetType;
};

/** Represents the payout for a specific winning combination of a single bet type. */
export type ResultDividend = {
  readonly __typename?: 'ResultDividend';
  /** In tote betting, if no one holds a winning ticket for an exotic bet, the prize pool is carried over to a future event, creating a jackpot. This field displays the winning combination that would have won, providing a transparent record of why the carryover occurred. */
  readonly carriedOverDividendNumbers: Scalars['String'];
  /** The payout amount for a standard $1 unit. */
  readonly dividend: Scalars['Float'];
  /** A string representation of the winning combination (e.g., '1,2,3'). */
  readonly dividendCombinations: Scalars['String'];
  /** An array of the runner numbers that form the winning combination. */
  readonly dividendNumbers: ReadonlyArray<Scalars['Int']>;
  /** The amount of any jackpot associated with this dividend. */
  readonly jackpot: Scalars['Float'];
  /** The total size of the betting pool for this specific bet type. */
  readonly poolSize: Scalars['Int'];
  /** The status of this dividend (e.g., INTERIM, FINAL). */
  readonly status: ResultStatus;
  /** The bet type this dividend is for (e.g., TRIFECTA, QUINELLA). */
  readonly type: BetType;
};

/** Describes the finishing place and margin for a single competitor in a race. */
export type ResultPosition = {
  readonly __typename?: 'ResultPosition';
  /** The full Competitor object for this position. Note: This field is unavailable in subscription streams. */
  readonly competitor: Competitor;
  /** The official margin in lengths behind the previous finisher. The winner's margin is `null`. */
  readonly margin?: Maybe<Scalars['Float']>;
  /** The official finishing place. */
  readonly position: Scalars['Int'];
  /** A reference back to the parent `ResultSet`. */
  readonly resultSet: ResultSet;
  /** The official run time of each runner */
  readonly runTime?: Maybe<Scalars['Float']>;
  /** The runner number of the competitor. */
  readonly tabNo: Scalars['Int'];
};

/** Contains the complete official results for a single race, including placings, dividends, and deductions from a specific source. */
export type ResultSet = {
  readonly __typename?: 'ResultSet';
  /** The timestamp when this result set was created. */
  readonly created: Scalars['TimeStamp'];
  /** A list of any official deductions applied to payouts, typically for late scratchings. */
  readonly deductions: ReadonlyArray<ResultDeduction>;
  /** A list of payout dividends for all available bet types. */
  readonly dividends: ReadonlyArray<ResultDividend>;
  /** A list of the official finishing positions for each competitor. */
  readonly positions: ReadonlyArray<ResultPosition>;
  /** The full Race object associated with these results. Note: This field is unavailable in subscriptions. */
  readonly race: Race;
  /** The unique identifier of the race these results apply to. */
  readonly raceId: Scalars['ID'];
  /** The data provider that supplied these results. */
  readonly source: Scalars['String'];
  /** The current status of the results (e.g., INTERIM, FINAL). */
  readonly status: ResultStatus;
  /** The timestamp of the last update to this result set. */
  readonly updated: Scalars['TimeStamp'];
};

export enum ResultStatus {
  Abandoned = 'ABANDONED',
  Final = 'FINAL',
  Interim = 'INTERIM',
  Partialpay = 'PARTIALPAY',
  Pending = 'PENDING',
  Protest = 'PROTEST',
  Reresult = 'RERESULT'
}

/** Deprecated. Represents the return on investment for a set of runs. */
export type ReturnOnInvestment = {
  readonly __typename?: 'ReturnOnInvestment';
  readonly absolute?: Maybe<Scalars['Float']>;
  readonly percentage?: Maybe<Scalars['Float']>;
  readonly roundedAbsolute?: Maybe<Scalars['Float']>;
  readonly roundedPercentage?: Maybe<Scalars['Float']>;
  readonly roundedTotalStake?: Maybe<Scalars['Float']>;
  readonly totalStake?: Maybe<Scalars['Float']>;
};

/** Contains information about a Rule 4 deduction, which is applied to winning bets when a competitor is withdrawn from a race. This is primarily used in UK racing. */
export type Rule4 = {
  readonly __typename?: 'Rule4';
  /** The type of market the deduction applies to (e.g., 'Race', 'Derivative'). */
  readonly DeductionType: Scalars['String'];
  /** A list of the specific deduction calculations, often time-based. */
  readonly Deductions: ReadonlyArray<DeductionRule4>;
  /** The unique identifier for the market this deduction applies to. */
  readonly MarketID?: Maybe<Scalars['String']>;
  /** The official source that declared the deduction. */
  readonly Source: Scalars['String'];
};

export enum Rule4DeductionType {
  Derivative = 'Derivative',
  Race = 'Race'
}

/** A real-time update payload for Rule 4 deductions. */
export type Rule4Update = {
  readonly __typename?: 'Rule4Update';
  /** The type of market the deduction applies to. */
  readonly DeductionType: Scalars['String'];
  /** The updated list of deduction calculations. */
  readonly Deductions: ReadonlyArray<DeductionRule4>;
  /** The ID for the market this deduction applies to. */
  readonly MarketID?: Maybe<Scalars['String']>;
  /** The ID of the race for this update. */
  readonly RaceID: Scalars['String'];
  /** The official source that declared the deduction. */
  readonly Source: Scalars['String'];
};

export type Runner = {
  readonly __typename?: 'Runner';
  readonly competitorsConnection: RunnerCompetitorsConnection;
  readonly id: Scalars['ID'];
};


export type RunnerCompetitorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type RunnerCompetitorEdge = {
  readonly __typename?: 'RunnerCompetitorEdge';
  readonly cursor: Scalars['ID'];
  readonly node?: Maybe<Competitor>;
};

export type RunnerCompetitorsConnection = {
  readonly __typename?: 'RunnerCompetitorsConnection';
  readonly competitors?: Maybe<ReadonlyArray<Competitor>>;
  readonly edges?: Maybe<ReadonlyArray<RunnerCompetitorEdge>>;
  readonly pageInfo?: Maybe<PageInfo>;
  readonly totalCount: Scalars['Int'];
};

export type RunnerData = {
  readonly __typename?: 'RunnerData';
  readonly owners: Scalars['String'];
  readonly sex: Scalars['String'];
};

/** Represents a complete performance record for a single competitor in one of their past races, commonly known as a 'form line'. */
export type RunnerForm = {
  readonly __typename?: 'RunnerForm';
  /** The age restrictions for the race. */
  readonly ageRestriction: AgeRestriction;
  /** The starting barrier or gate number assigned to the competitor. */
  readonly barrier: Scalars['Int'];
  /** The class or grade of the race (e.g., 'MDN-SW', 'Group 1'). */
  readonly class: Scalars['String'];
  /** The date the race was run. */
  readonly date: Scalars['TimeStamp'];
  /**
   * The distance of the race, standardized to meters. This value is calculated from various source units (e.g., Furlongs, Yards, Kilometers) and rounded to the nearest integer. Data is not always consistent, we try our best to ensure it's in meters.
   *
   * METERS: value
   * FURLONGS: value * 201.168
   * KILOMETERS: value * 1000
   * MILES: value * 1609.34
   * YARDS: value * 0.9144
   * FEET: value * 0.3048
   */
  readonly distance: Scalars['Int'];
  /** The official time taken for the winner to complete the race, in milliseconds. */
  readonly elapsedTime: Scalars['Int'];
  /** A list of any declared equipment or gear for the competitor in this race. */
  readonly equipments?: Maybe<ReadonlyArray<ValueDescriptionItem>>;
  /** If the competitor did not finish, this provides the reason. An empty string indicates it most likely finished. */
  readonly failedToFinishReason: Scalars['String'];
  /** The competitor's official finishing position in the race. */
  readonly finishingPosition: Scalars['Int'];
  /** For Harness racing, the time taken for the first split of the race, in seconds. Will be 0 for other codes. */
  readonly firstSplitSeconds: Scalars['Float'];
  /** Fractional timing data for the race. */
  readonly fractions?: Maybe<ReadonlyArray<Fraction>>;
  /** The competitor's age in days at the time of the race. */
  readonly fullAgeDays: Scalars['Int'];
  /** The competitor's age in months at the time of the race. */
  readonly fullAgeMonths: Scalars['Int'];
  /** The competitor's age in years at the time of the race. */
  readonly fullAgeYears: Scalars['Int'];
  /** The unique meeting identifier from the GBS system. */
  readonly gbsMeetingId: Scalars['String'];
  /** A description of any gear the competitor wore for this race. */
  readonly gearChanges: Scalars['String'];
  /** For standing start Harness races, the handicap in meters behind the front tape. Will be 0 for other codes. */
  readonly handicapMetres: Scalars['Int'];
  /** A string describing the competitor's position at various points during the race (e.g., '800m, 400m, Finish'). */
  readonly inRun: Scalars['String'];
  /** A flag indicating if this performance was in an unofficial jumpout, not a formal trial or race. */
  readonly isJumpout: Scalars['Boolean'];
  /** A flag indicating if this was a jumps race (e.g., hurdles or steeplechase). */
  readonly isJumps: Scalars['Boolean'];
  /** For Harness racing, a flag indicating if the race had a mobile start. */
  readonly isMobileStart: Scalars['Boolean'];
  /** A flag indicating if this performance was in an official trial rather than a race. */
  readonly isTrial: Scalars['Boolean'];
  /** The name of the jockey. */
  readonly jockey: Scalars['String'];
  /** The unique global identifier for the jockey. */
  readonly jockeyGlobalId: Scalars['ID'];
  /** For Harness racing, the time taken to run the last mile of the race, in seconds. Will be 0 for other codes. */
  readonly lastMileSeconds: Scalars['Float'];
  /** The minimum weight for the race. */
  readonly limitWeight: Scalars['Float'];
  readonly margin: Scalars['Float'];
  /** The maximum claim price for the race, if applicable. */
  readonly maximumClaimPrice: Scalars['Float'];
  /** A list of any declared medications for the competitor in this race. */
  readonly medications?: Maybe<ReadonlyArray<ValueDescriptionItem>>;
  /** The competitor's mid-betting price, if available. */
  readonly midPrice: Scalars['Float'];
  /** For Harness racing, the equivalent time it would have taken to run one mile, in seconds. Will be 0 for other codes. */
  readonly mileRateSeconds: Scalars['Float'];
  /** The minimum claim price for the race, if applicable. */
  readonly minimumClaimPrice: Scalars['Float'];
  /** The competitor's opening betting price, if available. */
  readonly openingPrice: Scalars['Float'];
  /** A list of the other placed horses in the race, providing context for the performance. Can be filtered by finishing position. */
  readonly placeGetters?: Maybe<ReadonlyArray<FormPlaceGetter>>;
  /** Positional data at specific points of call during the race. */
  readonly pointOfCalls?: Maybe<ReadonlyArray<PointOfCall>>;
  /** The total career prize money earned by the competitor up to this race. */
  readonly prizeMoneyWon: Scalars['Float'];
  /** The amount of prize money the competitor won in this specific race. */
  readonly prizeMoneyWonThisRace: Scalars['Float'];
  /** The total prize money pool for the race. */
  readonly prizeTotal: Scalars['Int'];
  /** The benchmark rating for the race. */
  readonly raceBenchMark: Scalars['Float'];
  readonly raceGroup: Scalars['Int'];
  /** The unique identifier for the race. */
  readonly raceId: Scalars['String'];
  /** The official name of the race. */
  readonly raceName: Scalars['String'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** A list of sectional times for the race. */
  readonly raceSectionals?: Maybe<ReadonlyArray<RaceSectional>>;
  /** The distance of the rail from its true position, in meters. */
  readonly railDistance: Scalars['Int'];
  /** An unadjusted performance rating for the competitor in this race. */
  readonly ratingUnadjusted: Scalars['Float'];
  /** For Harness racing, the starting row number. Will be 0 for other codes. */
  readonly row: Scalars['Int'];
  /** The distance from the starting gates to the point where timing for the official race distance begins. */
  readonly runUpDistance: Scalars['Int'];
  /** The name of the runner. */
  readonly runner: Scalars['String'];
  /** The unique global identifier for the runner. */
  readonly runnerGlobalId: Scalars['ID'];
  /** The sex restrictions for the race. */
  readonly sexRestriction: SexRestriction;
  /** A rating of the race's overall speed. */
  readonly speed: Scalars['Int'];
  /** The competitor's age standardized to a single integer. */
  readonly standardisedAge: Scalars['Int'];
  readonly startCount: Scalars['Int'];
  /** The total number of official starters in the race. */
  readonly starters: Scalars['Int'];
  /** The competitor's final starting price (SP). */
  readonly startingPrice: Scalars['Float'];
  /** Any official comments from the race stewards regarding this competitor's performance. */
  readonly stewardsComment: Scalars['String'];
  /** The runner number assigned to the competitor for the race, if available. */
  readonly tabNumber: Scalars['Int'];
  /** The name of the track where the race was held. */
  readonly track: Scalars['String'];
  /** A short abbreviation for the track name. */
  readonly trackAbbr: Scalars['String'];
  /** The official track condition at the time of the race (e.g., 'GOOD4'). */
  readonly trackCondition: Scalars['String'];
  /** The country of the track. */
  readonly trackCountry: Scalars['String'];
  /** A numerical rating for the track condition. */
  readonly trackRating: Scalars['Int'];
  /** The state or province of the track. */
  readonly trackState: Scalars['String'];
  /** The surface type of the track (e.g., 'Turf', 'Synthetic'). */
  readonly trackSurface: Scalars['String'];
  /** The name of the trainer. */
  readonly trainer: Scalars['String'];
  /** The unique global identifier for the trainer. */
  readonly trainerGlobalId: Scalars['ID'];
  /** A standardized performance rating scale. */
  readonly universalScale: Scalars['String'];
  /** Links and identifiers for race replay videos. Note: Only available on V2. */
  readonly videoDetails?: Maybe<ReadonlyArray<VideoDetails>>;
  /** The weight the competitor carried in the race. */
  readonly weight: Scalars['Float'];
};


/** Represents a complete performance record for a single competitor in one of their past races, commonly known as a 'form line'. */
export type RunnerFormPlaceGettersArgs = {
  finishingPositions?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

/** A notification that a runner's form or statistics have been updated. */
export type RunnerFormUpdated = {
  readonly __typename?: 'RunnerFormUpdated';
  /** The global runner ID that can be used to fetch updated form/stats. */
  readonly globalId: Scalars['ID'];
  /** The type of update (FORM or RUNNER_STATISTICS). */
  readonly type: FormStatsUpdatedType;
};

export type RunnerIdentifier = {
  readonly __typename?: 'RunnerIdentifier';
  /** ISO 3166-1 alpha-3 country code */
  readonly countryOfBirth: Scalars['String'];
  readonly dam: Scalars['String'];
  readonly dob: Scalars['TimeStamp'];
  readonly globalId: Scalars['ID'];
  readonly meetingType: Scalars['String'];
  readonly name: Scalars['String'];
  readonly sire: Scalars['String'];
};

export type RunnerResult = {
  readonly __typename?: 'RunnerResult';
  readonly runnerIdentifier: RunnerIdentifier;
  readonly sourceRunners: ReadonlyArray<Maybe<RunnerIdentifier>>;
  readonly targetRunner: RunnerIdentifier;
};

/** Provides details about a single withdrawn runner that is part of a Rule 4 deduction calculation. */
export type ScratchedRunnerRule4 = {
  readonly __typename?: 'ScratchedRunnerRule4';
  /** The specific deduction amount attributed to this runner's withdrawal. */
  readonly Deduction: Scalars['Float'];
  /** The name of the withdrawn runner. */
  readonly Name: Scalars['String'];
  /** The number of the withdrawn runner. */
  readonly Number: Scalars['Int'];
  /** The price of the runner at the time of withdrawal. */
  readonly Price: Scalars['Float'];
};

/** A notification payload that is sent when a competitor is scratched (withdrawn) from a race. */
export type Scratching = {
  readonly __typename?: 'Scratching';
  /** The unique identifier of the meeting where the scratching occurred. */
  readonly meetingId: Scalars['ID'];
  /** The unique identifier of the race from which the competitor was scratched. */
  readonly raceId: Scalars['ID'];
  /** The name of the race. */
  readonly raceName: Scalars['String'];
  /** The number of the race within the meeting. */
  readonly raceNumber: Scalars['Int'];
  /** The name of the competitor that was scratched. */
  readonly runnerName: Scalars['String'];
  /** The runner number of the competitor that was scratched. */
  readonly runnerNumber: Scalars['Int'];
  /** The type of scratching, indicating when the withdrawal occurred (e.g., SCRATCHED, LATESCRATCHING). */
  readonly scratchingType: ScratchingType;
};

export enum ScratchingType {
  Latescratching = 'LATESCRATCHING',
  Scratched = 'SCRATCHED',
  Starter = 'STARTER'
}

/** Defines the sex of competitors eligible for a race (e.g., Fillies & Mares only). */
export type SexRestriction = {
  readonly __typename?: 'SexRestriction';
  /** A list of the sexes that are permitted to compete. */
  readonly restrictedTo?: Maybe<ReadonlyArray<Scalars['String']>>;
};

/** Represents a single competitor/runner in a race, containing all of its relevant details, statistics, and race-specific information. */
export enum SilksType {
  Png = 'PNG',
  Svg = 'SVG'
}

/** Represents a data provider. */
export type Source = {
  readonly __typename?: 'Source';
  /** The unique identifier for the data provider. This is the value used when filtering queries by source. */
  readonly code: Scalars['String'];
  /** An internal system identifier for the source, generally used for internal mapping. */
  readonly gbsCode: Scalars['String'];
  /** A flag that is `true` if the provider offers prices and betting odds. */
  readonly isPriceSource: Scalars['Boolean'];
  /** Human readable name of the provider, suitable for display. */
  readonly name: Scalars['String'];
  readonly platformType: PlatformType;
};

/** Represents a single piece of commentary or analysis from a specific data provider. */
export type SourceComment = {
  readonly __typename?: 'SourceComment';
  /** The text content of the comment or tip. */
  readonly comment: Scalars['String'];
  /** Permissions required - The language of the comment text. */
  readonly language: Language;
  /** The data provider that supplied the comment. */
  readonly source: Scalars['String'];
  /** The status of the comment (e.g., ACTIVE). */
  readonly status: Status;
};

export type SourceId = {
  readonly __typename?: 'SourceId';
  readonly id: Scalars['String'];
  readonly source: Scalars['String'];
};

/** Career statistics related to performance after a spell (a break from racing). */
export type Spell = {
  readonly __typename?: 'Spell';
  /** Performance in the first race after a spell. */
  readonly firstUp?: Maybe<PlacingStats>;
  /** Performance in the fourth race after a spell. */
  readonly fourthUp?: Maybe<PlacingStats>;
  /** Performance in the second race after a spell. */
  readonly secondUp?: Maybe<PlacingStats>;
  /** Performance in the third race after a spell. */
  readonly thirdUp?: Maybe<PlacingStats>;
};

/** An input object representing a single leg (selection) to be included in a Same Race Multi price request. */
export type SrmLeg = {
  /** The finishing positions this leg covers. */
  readonly positions: ReadonlyArray<Scalars['Int']>;
  /** The runner number for this leg of the multi. */
  readonly runnerNumber: Scalars['Int'];
};

/** A list of pre-calculated prices for a single runner to finish in various positions, used for building Same Race Multi bets. */
export type SrmListPrice = {
  readonly __typename?: 'SrmListPrice';
  /** The runner number these prices apply to. */
  readonly runnerNumber: Scalars['Int'];
  /** The price for the runner to finish in the Top 2. */
  readonly top2Price: Scalars['Float'];
  /** The price for the runner to finish in the Top 3. */
  readonly top3Price: Scalars['Float'];
  /** The price for the runner to finish in the Top 4. */
  readonly top4Price: Scalars['Float'];
  /** The price for the runner to finish 1st. */
  readonly winPrice: Scalars['Float'];
};

/** Represents the calculated price and margin for a Same-Race-Multi bet. */
export type SrmSelectionPrice = {
  readonly __typename?: 'SrmSelectionPrice';
  /** The bookmaker's margin that is included in the calculated price. */
  readonly margin: Scalars['Float'];
  /** The calculated decimal odds for the combined Same-Race-Multi selections. */
  readonly price: Scalars['Float'];
};

/** A comprehensive collection of performance statistics for a competitor, jockey, or trainer. */
export type Statistics = {
  readonly __typename?: 'Statistics';
  /** Overall performance statistics across all starts. */
  readonly all?: Maybe<PlacingStats>;
  /** Performance statistics grouped by ranges of barrier numbers. */
  readonly barrierRangePlaces?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  /** Performance statistics for the current campaign. */
  readonly campaign?: Maybe<PlacingStats>;
  /** A detailed breakdown of career performance statistics. */
  readonly career?: Maybe<Career>;
  /** Performance statistics grouped by track condition (e.g., 'GOOD4', 'HEAVY8'). */
  readonly conditionPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics grouped by a combination of distance and track condition. */
  readonly distanceAndConditionPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics grouped by race distance. */
  readonly distancePlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics grouped by ranges of race distances. */
  readonly distanceRangePlaces?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  /** Performance statistics grouped by ranges of field sizes (number of starters). */
  readonly fieldSizeRangePlaces?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  /** Performance statistics for the first race after a spell (a break from racing). */
  readonly firstUp?: Maybe<PlacingStats>;
  /** Performance statistics for the fourth race after a spell. */
  readonly fourthUp?: Maybe<PlacingStats>;
  /** Performance statistics grouped by jockey. */
  readonly jockeyPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /**
   * A string representing the finishing positions of the competitor's last 10 races, with the most recent start appearing on the right. Each character in the string is a code for the outcome of a race:
   *
   * - **`1-9`**: Represents the horse's exact finishing position.
   * - **`0`**: Indicates the horse finished in 10th place or worse.
   * - **`x`**: Signifies the race occurred after a "spell".
   * - **`-`**: Means the horse either failed to finish or was disqualified.
   * - **`?`**: Indicates the finishing position is unknown, possibly due to a data issue.
   */
  readonly last10Starts?: Maybe<Scalars['String']>;
  /** Performance statistics for the previous racing season. */
  readonly lastSeason?: Maybe<PlacingStats>;
  /** The number of 1st place finishes in the last 4 starts. */
  readonly numberOfFirstsInLast4?: Maybe<Scalars['Int']>;
  /** The number of 1st place finishes in the last 10 starts. */
  readonly numberOfFirstsInLast10?: Maybe<Scalars['Int']>;
  /** The number of place finishes in the last 4 starts. */
  readonly numberOfPlacesInLast4?: Maybe<Scalars['Int']>;
  /** The number of place finishes in the last 10 starts. */
  readonly numberOfPlacesInLast10?: Maybe<Scalars['Int']>;
  /** A set of proprietary performance metrics. */
  readonly performances?: Maybe<Performances>;
  /** The current streak of consecutive placing finishes. */
  readonly placingStreak?: Maybe<Scalars['Int']>;
  /** Performance statistics grouped by ranges of competitor ages. */
  readonly raceAgeRangePlaces?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  /** A summary of recent form indicators. */
  readonly recent?: Maybe<Recent>;
  /** Performance statistics for the second race after a spell. */
  readonly secondUp?: Maybe<PlacingStats>;
  /** Performance statistics grouped by track surface (e.g., 'Turf', 'Synthetic'). */
  readonly surfacePlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics for the third race after a spell. */
  readonly thirdUp?: Maybe<PlacingStats>;
  /** Performance statistics for the current campaign. */
  readonly thisCampaign?: Maybe<PlacingStats>;
  /** Performance statistics for the current racing season. */
  readonly thisSeason?: Maybe<PlacingStats>;
  /** Performance statistics grouped by a combination of track and distance. */
  readonly trackAndDistancePlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics grouped by track. */
  readonly trackPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics for a specific trainer and jockey combination. */
  readonly trainerAndJockeyPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics grouped by trainer. */
  readonly trainerPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics grouped by the weight carried. */
  readonly weightPlaces?: Maybe<ReadonlyArray<KeyedPlacingStats>>;
  /** Performance statistics grouped by ranges of weight carried. */
  readonly weightRangePlaces?: Maybe<ReadonlyArray<DecimalRangedPlacingStats>>;
  /** The current streak of consecutive wins. */
  readonly winningStreak?: Maybe<Scalars['Int']>;
};

export enum Status {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE'
}

export type Subscription = {
  readonly __typename?: 'Subscription';
  /** Only available to BetFair subscribers. */
  readonly betFairUpdates: BetFairMarket;
  /** Streams real-time comment updates for a given race. */
  readonly commentUpdates: CommentUpdate;
  /** Regulated VIC and SOD deductions. */
  readonly deductionUpdates: DeductionSet;
  /** Streams updates for exotic bet types, such as pools and dividends, for a specific race. */
  readonly exoticUpdates: ExoticUpdate;
  /** TODO */
  readonly formStatsUpdates: FormStatsUpdated;
  /** Subscribes to real-time updates for a specific futures event. */
  readonly futureEventUpdates: FuturesV2EventUpdate;
  /** Subscription is only for price manager clients, streams generated derivatives for linked price manager */
  readonly generatedDerivative: Derivative;
  /** Streams generated exotics for a specific race. */
  readonly generatedExotic: GeneratedExotic;
  /** Only for price manager clients, streams generated prices for linked price manager */
  readonly generatedPrice: PriceSet;
  /** Streams real-time updates for live form data for a given meeting. */
  readonly liveFormUpdated: LiveFormUpdated;
  /** Provides real-time updates on the pre-jump status of a race (e.g., going behind, last horse in). */
  readonly preJumpRaceStatusUpdated: PreJumpRaceStatusUpdate;
  /**
   * TODO
   * @deprecated No longer supported
   */
  readonly predictedRatingUpdates: PredictedRatingUpdate;
  /** Streams live price updates for a given race, with options to filter by `sources` and `sourceTypes`. */
  readonly priceUpdates: PriceSet;
  /** Discovery for when a race is newly priced */
  readonly racePriced: RacePriced;
  /** Streams real-time updates to the status of a race (e.g., OPEN, CLOSED, ABANDONED). */
  readonly raceStatusUpdated: RaceStatusUpdate;
  /** Subscribes to updates for a specific race, providing real-time changes to race details. */
  readonly raceUpdated: RaceUpdate;
  /** Streams competitors' RACELAB Insights at a race level */
  readonly racelabInsights: RacelabInsightsUpdated;
  /** Provides real-time race results, including positions and dividends, as they become available. */
  readonly results: ResultSet;
  /** Rule 4 deductions are UK specific and for UK clients only. */
  readonly rule4Updates: Rule4Update;
  /** Subscribes to real-time notifications when a runner's form or statistics are updated. Use the globalId from the notification to fetch updated data via runnerFormHistory or runnerStats queries. */
  readonly runnerFormUpdated: RunnerFormUpdated;
  /** Provides real-time notifications when a runner is scratched from a race. */
  readonly scratching: Scratching;
  /** Notifies you of substitute runner updates for a given race. */
  readonly substituteUpdates: RacePoolSubstituteUpdates;
  /** This subscription is only available for TOTE terminals */
  readonly toteProductUpdates: ToteProductUpdate;
  /** Streams real-time results and dividends for virtual races. */
  readonly virtualRaceResultUpdates: VirtualRaceResult;
  /** Subscribes to real-time updates on selections and odds for virtual races. */
  readonly virtualRaceSelectionUpdates: VirtualSelections;
  /** Provides real-time updates on the status of virtual races. */
  readonly virtualRaceStatusUpdates: VirtualRaceStatusUpdate;
  /** Provides real-time updates for virtual races from a specific source. */
  readonly virtualRaceUpdates: VirtualRace;
};


export type SubscriptionBetFairUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  types?: InputMaybe<ReadonlyArray<BetFairPriceType>>;
};


export type SubscriptionCommentUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionDeductionUpdatesArgs = {
  include_emergencies?: InputMaybe<Scalars['Boolean']>;
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionExoticUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  resultsOnly?: InputMaybe<Scalars['Boolean']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  type?: InputMaybe<BetType>;
};


export type SubscriptionFormStatsUpdatesArgs = {
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  updateType?: InputMaybe<ReadonlyArray<FormStatsUpdatedType>>;
};


export type SubscriptionFutureEventUpdatesArgs = {
  eventId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionGeneratedDerivativeArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionGeneratedPriceArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionLiveFormUpdatedArgs = {
  meetingId?: InputMaybe<Scalars['ID']>;
  source: Scalars['String'];
};


export type SubscriptionPredictedRatingUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionPriceUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sourceTypes?: InputMaybe<ReadonlyArray<InputSourceType>>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionRaceUpdatedArgs = {
  dated?: InputMaybe<Scalars['Time']>;
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionResultsArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionRule4UpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
};


export type SubscriptionSubstituteUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionToteProductUpdatesArgs = {
  raceId?: InputMaybe<Scalars['ID']>;
  sources?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};


export type SubscriptionVirtualRaceResultUpdatesArgs = {
  betTypes?: InputMaybe<ReadonlyArray<VirtualBetType>>;
  source: Scalars['String'];
};


export type SubscriptionVirtualRaceSelectionUpdatesArgs = {
  betTypes?: InputMaybe<ReadonlyArray<VirtualBetType>>;
  source: Scalars['String'];
};


export type SubscriptionVirtualRaceStatusUpdatesArgs = {
  source: Scalars['String'];
};


export type SubscriptionVirtualRaceUpdatesArgs = {
  source: Scalars['String'];
};

/** Career statistics grouped by various ranges. */
export type Summary = {
  readonly __typename?: 'Summary';
  /** Stats by ranges of barrier numbers. */
  readonly byBarrier?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  /** Stats by ranges of distances. */
  readonly byDistance?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  /** Stats by ranges of field sizes. */
  readonly byFieldSize?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  /** Stats by ranges of competitor ages. */
  readonly byRaceAge?: Maybe<ReadonlyArray<Int32RangedPlacingStats>>;
  /** Stats by ranges of weight carried. */
  readonly byWeight?: Maybe<ReadonlyArray<DecimalRangedPlacingStats>>;
};

export enum TotePoolType {
  Choose6 = 'CHOOSE6',
  Double = 'DOUBLE',
  Doubletrio = 'DOUBLETRIO',
  Exact6 = 'EXACT6',
  Exacta = 'EXACTA',
  G75 = 'G75',
  Grandslam = 'GRANDSLAM',
  Jackpot = 'JACKPOT',
  Nfl5 = 'NFL5',
  Omni = 'OMNI',
  Onetwothree = 'ONETWOTHREE',
  Pentafecta = 'PENTAFECTA',
  Pick3 = 'PICK3',
  Pick4 = 'PICK4',
  Pick5 = 'PICK5',
  Pick6 = 'PICK6',
  Pick7 = 'PICK7',
  Pick8 = 'PICK8',
  Pick9 = 'PICK9',
  Pick10 = 'PICK10',
  Pickx = 'PICKX',
  Place = 'PLACE',
  Placepot = 'PLACEPOT',
  Pmu2Sur4 = 'PMU2SUR4',
  Pmu4Plus = 'PMU4PLUS',
  Pmu5Plus = 'PMU5PLUS',
  Pmuclassictierce = 'PMUCLASSICTIERCE',
  Pmuminimulti = 'PMUMINIMULTI',
  Pmumulti = 'PMUMULTI',
  Pmupick5 = 'PMUPICK5',
  Pmutierce = 'PMUTIERCE',
  Pmutrio = 'PMUTRIO',
  Quadpot = 'QUADPOT',
  Quinella = 'QUINELLA',
  Racingo = 'RACINGO',
  Scoop6 = 'SCOOP6',
  Show = 'SHOW',
  Sixup = 'SIXUP',
  Superfecta = 'SUPERFECTA',
  Survivor4 = 'SURVIVOR4',
  Survivor5 = 'SURVIVOR5',
  Survivor6 = 'SURVIVOR6',
  Survivor7 = 'SURVIVOR7',
  Survivor8 = 'SURVIVOR8',
  Survivor9 = 'SURVIVOR9',
  Survivor10 = 'SURVIVOR10',
  T64 = 'T64',
  T75 = 'T75',
  Trifecta = 'TRIFECTA',
  Trio = 'TRIO',
  Tripletrio = 'TRIPLETRIO',
  V4 = 'V4',
  V5 = 'V5',
  V64 = 'V64',
  V65 = 'V65',
  V75 = 'V75',
  V86 = 'V86',
  Vpick = 'VPICK',
  Win = 'WIN',
  Winscore = 'WINSCORE'
}

export type ToteProduct = {
  readonly __typename?: 'ToteProduct';
  readonly betStyle: Scalars['String'];
  readonly betTypeId: Scalars['Int'];
  readonly id: BetType;
  readonly increment: Scalars['Float'];
  readonly maxBetAmt: Scalars['Float'];
  readonly maxBetCost: Scalars['Float'];
  readonly maxCombs: Scalars['Float'];
  readonly minBetAmt: Scalars['Float'];
  readonly minBetCost: Scalars['Float'];
  readonly minCombs: Scalars['Float'];
  readonly minimumStake: Scalars['Float'];
  readonly poolName: Scalars['String'];
  readonly poolType: TotePoolType;
  readonly races: Scalars['String'];
};

export type ToteProductUpdate = {
  readonly __typename?: 'ToteProductUpdate';
  readonly meetingId: Scalars['String'];
  readonly raceNumber: Scalars['Int'];
  readonly source: Scalars['String'];
  readonly toteProducts: ReadonlyArray<ToteProduct>;
};

/** Represents a racing track/venue where meetings are held. */
export type Track = {
  readonly __typename?: 'Track';
  /** A short, commonly used abbreviation for the track's name. */
  readonly abbreviation: Scalars['String'];
  /** A four-character abbreviation for the track. */
  readonly abbreviationFourChar: Scalars['String'];
  /** The country where the track is located (ISO 3166-1 alpha-3 country code). */
  readonly country: Scalars['String'];
  /** The timestamp when the track was first added to the system. */
  readonly created: Scalars['TimeStamp'];
  /** The unique internal identifier for the track. */
  readonly id: Scalars['ID'];
  /** The geographical location type of the track (e.g., METRO, COUNTRY). */
  readonly location: TrackLocation;
  /** A paginated list of meetings held at this track. Can be filtered to show meetings after a specific date. */
  readonly meetingsConnection: TrackMeetingsConnection;
  /** The full, official name of the track. */
  readonly name: Scalars['String'];
  /** The state or province where the track is located. */
  readonly state: Scalars['String'];
  /** The primary racing surface of the track (e.g., Turf, Dirt). */
  readonly surface: Scalars['String'];
  /** The timestamp of the last update to the track's information. */
  readonly updated: Scalars['TimeStamp'];
};


/** Represents a racing track/venue where meetings are held. */
export type TrackMeetingsConnectionArgs = {
  afterDate?: InputMaybe<Scalars['TimeStamp']>;
  first?: InputMaybe<Scalars['Int']>;
};

/**
 * Represents the official condition of the track.
 * - **Australian Scale (FIRM1 - HEAVY10):** A numerical system used in Australia.
 * - **Standard Scale (FAST, GOOD, SOFT, etc.):** Descriptive terms used in most other regions.
 */
export enum TrackCondition {
  Dead = 'DEAD',
  Dead4 = 'DEAD4',
  Dead5 = 'DEAD5',
  Dead6 = 'DEAD6',
  Dead7 = 'DEAD7',
  Dead8 = 'DEAD8',
  Dead9 = 'DEAD9',
  Dirt = 'DIRT',
  Easy = 'EASY',
  Fair = 'FAIR',
  Fast = 'FAST',
  Fast1 = 'FAST1',
  Fast2 = 'FAST2',
  Firm = 'FIRM',
  Firm1 = 'FIRM1',
  Firm2 = 'FIRM2',
  Firm3 = 'FIRM3',
  Firm4 = 'FIRM4',
  Frozen = 'FROZEN',
  Good = 'GOOD',
  Good2 = 'GOOD2',
  Good3 = 'GOOD3',
  Good4 = 'GOOD4',
  Good5 = 'GOOD5',
  Good6 = 'GOOD6',
  GoodToFirm = 'GOOD_TO_FIRM',
  GoodToSoft = 'GOOD_TO_SOFT',
  GoodToYielding = 'GOOD_TO_YIELDING',
  Hard = 'HARD',
  Heavy = 'HEAVY',
  Heavy8 = 'HEAVY8',
  Heavy9 = 'HEAVY9',
  Heavy10 = 'HEAVY10',
  Heavy11 = 'HEAVY11',
  Heavy12 = 'HEAVY12',
  Heavy13 = 'HEAVY13',
  Muddy = 'MUDDY',
  Sand = 'SAND',
  Sloppy = 'SLOPPY',
  Slow = 'SLOW',
  Slow7 = 'SLOW7',
  Slow8 = 'SLOW8',
  Slow9 = 'SLOW9',
  Slow10 = 'SLOW10',
  Slow11 = 'SLOW11',
  Slow12 = 'SLOW12',
  Soft = 'SOFT',
  Soft5 = 'SOFT5',
  Soft6 = 'SOFT6',
  Soft7 = 'SOFT7',
  Soft8 = 'SOFT8',
  Soft9 = 'SOFT9',
  Soft10 = 'SOFT10',
  Standard = 'STANDARD',
  StandardToFast = 'STANDARD_TO_FAST',
  StandardToSlow = 'STANDARD_TO_SLOW',
  Synthetic = 'SYNTHETIC',
  UnknownCondition = 'UNKNOWN_CONDITION',
  VeryHeavy = 'VERY_HEAVY',
  WetFast = 'WET_FAST',
  Yielding = 'YIELDING',
  YieldingToSoft = 'YIELDING_TO_SOFT'
}

export enum TrackLocation {
  Country = 'COUNTRY',
  LocationF = 'LOCATION_F',
  LocationG = 'LOCATION_G',
  LocationUnknown = 'LOCATION_UNKNOWN',
  LocationX = 'LOCATION_X',
  Metro = 'METRO',
  Provincial = 'PROVINCIAL'
}

/** Represents an edge in the `TrackMeetingsConnection`, linking a cursor to a meeting node. */
export type TrackMeetingEdge = {
  readonly __typename?: 'TrackMeetingEdge';
  /** A unique identifier for this item in the paginated list, used to fetch subsequent pages. */
  readonly cursor: Scalars['ID'];
  /** The `Meeting` object at this position in the connection. */
  readonly node?: Maybe<Meeting>;
};

/** Provides a paginated list of meetings for a track, allowing for cursor-based navigation. */
export type TrackMeetingsConnection = {
  readonly __typename?: 'TrackMeetingsConnection';
  /** A list of connection edges, each containing a `cursor` and a meeting `node`. */
  readonly edges?: Maybe<ReadonlyArray<TrackMeetingEdge>>;
  /** A list of meeting objects for the current page. Best practice is to use `edges` for pagination. */
  readonly meetings?: Maybe<ReadonlyArray<Meeting>>;
  /** Information about the current page, such as start/end cursors and whether more pages are available. */
  readonly pageInfo?: Maybe<PageInfo>;
  /** The total number of meetings available for the track, ignoring pagination. */
  readonly totalCount: Scalars['Int'];
};

/** Contains a payload of real-time updates for a specific track. */
export type TrackUpdate = {
  readonly __typename?: 'TrackUpdate';
  /** The four-character abbreviation for the track. */
  readonly abbreviationFourChar: Scalars['String'];
  /** The country where the track is located (ISO 3166-1 alpha-3 country code). */
  readonly country: Scalars['String'];
  /** The timestamp when the track was first added to the system. */
  readonly created: Scalars['TimeStamp'];
  /** The unique internal identifier for the track. */
  readonly id: Scalars['ID'];
  /** The geographical location type of the track (e.g., METRO, COUNTRY). */
  readonly location: TrackLocation;
  /** The official name of the track. */
  readonly name: Scalars['String'];
  /** The state or province where the track is located. */
  readonly state: Scalars['String'];
  /** The timestamp of this specific update. */
  readonly updated: Scalars['TimeStamp'];
};

export type TrainerIdentifier = {
  readonly __typename?: 'TrainerIdentifier';
  readonly globalId: Scalars['ID'];
  readonly meetingType: Scalars['String'];
  readonly name: Scalars['String'];
};

export type TrainerResult = {
  readonly __typename?: 'TrainerResult';
  readonly sourceTrainers: ReadonlyArray<Maybe<TrainerIdentifier>>;
  readonly targetTrainer: TrainerIdentifier;
  readonly trainerIdentifier: TrainerIdentifier;
};

export type ValueDescriptionItem = {
  readonly __typename?: 'ValueDescriptionItem';
  readonly Description: Scalars['String'];
  readonly Value: Scalars['String'];
};

/** Contains links and identifiers for race replay videos from a specific provider. */
export type VideoDetails = {
  readonly __typename?: 'VideoDetails';
  /** An internal or provider-specific asset identifier for the video. */
  readonly videoAssetId?: Maybe<Scalars['String']>;
  /** The unique identifier for the video on the provider's platform. */
  readonly videoId?: Maybe<Scalars['String']>;
  /** The provider of the video (e.g., 'YouTube', 'Vimeo'). */
  readonly videoProvider: Scalars['String'];
  /** The direct URL to watch the video. */
  readonly videoURL?: Maybe<Scalars['String']>;
};

export enum VirtualBetType {
  Exacta = 'EXACTA',
  H2HBestVsSecond = 'H2H_BEST_VS_SECOND',
  H2HSecondVsThird = 'H2H_SECOND_VS_THIRD',
  H2HThirdVsFourth = 'H2H_THIRD_VS_FOURTH',
  HighLow = 'HIGH_LOW',
  LastPlace = 'LAST_PLACE',
  LastThree = 'LAST_THREE',
  OddEven = 'ODD_EVEN',
  Place = 'PLACE',
  Quinella = 'QUINELLA',
  SecondPlace = 'SECOND_PLACE',
  SumFirstThree = 'SUM_FIRST_THREE',
  SumFirstTwo = 'SUM_FIRST_TWO',
  Swinger = 'SWINGER',
  ThirdPlace = 'THIRD_PLACE',
  Trifecta = 'TRIFECTA',
  Trio = 'TRIO',
  Win = 'WIN'
}

/** Groups all available betting selections for a single bet type. */
export type VirtualBetTypeGroup = {
  readonly __typename?: 'VirtualBetTypeGroup';
  /** The bet type for this group of selections. */
  readonly betType: VirtualBetType;
  /** A list of all the betting selections available for this bet type. */
  readonly selections: ReadonlyArray<VirtualSelectionEntry>;
};

/** Represents a single competitor within a virtual race. */
export type VirtualCompetitor = {
  readonly __typename?: 'VirtualCompetitor';
  /** The timestamp when the virtual competitor was created. */
  readonly created: Scalars['TimeStamp'];
  /** The unique internal identifier for the virtual competitor. */
  readonly id: Scalars['ID'];
  /** The name of the virtual competitor. */
  readonly name: Scalars['String'];
  /** Number of races since the competitor's last placing. */
  readonly racesSincePlace: Scalars['Int'];
  /** Number of races since the competitor's last win. */
  readonly racesSinceWin: Scalars['Int'];
  /** Competitor's recent form (e.g., '1x243'). */
  readonly runnerLastStarts: Scalars['String'];
  /** The runner number of the competitor. */
  readonly runnerNumber: Scalars['Int'];
  /** Star rating indicating the competitor's perceived ability. */
  readonly runnerStarRating: Scalars['Float'];
  /** The competitor's unique identifier from the data provider's system. */
  readonly sourceCompetitorId: Scalars['String'];
  /** The timestamp of the last update to the virtual competitor's information. */
  readonly updated: Scalars['TimeStamp'];
};

/** Represents a single virtual (computer-simulated) racing event. */
export type VirtualRace = {
  readonly __typename?: 'VirtualRace';
  /** A list of the competitors in the race. */
  readonly competitors: ReadonlyArray<VirtualCompetitor>;
  /** The timestamp when the virtual race was created. */
  readonly created: Scalars['TimeStamp'];
  /** The distance of the virtual race in meters. */
  readonly distance: Scalars['Int'];
  /** The time the virtual race is scheduled to finish. */
  readonly finishTime: Scalars['TimeStamp'];
  /** The unique internal identifier for the virtual race. */
  readonly id: Scalars['ID'];
  /** The resulting multiplier bonus that was applied to winning bets. */
  readonly multiplierResult: Scalars['Int'];
  /** The stake required to be eligible for the multiplier bonus feature. */
  readonly multiplierStake: Scalars['Int'];
  /** A string representing the possible multiplier bonus values. */
  readonly multiplierValues: Scalars['String'];
  /** The name of the virtual race. */
  readonly name: Scalars['String'];
  /** The number of the race within the virtual meeting schedule. */
  readonly number: Scalars['Int'];
  /** The number of finishing positions that pay a place dividend. */
  readonly placePayoutPositions: Scalars['Int'];
  /** The current status of the race (e.g., OPEN_FOR_BETTING, IN_PROGRESS, FINISHED). */
  readonly raceStatus: VirtualRaceStatus;
  /** The type of virtual racing (e.g., DASHING_DERBY, PLATINUM_HOUNDS). */
  readonly raceType: VirtualRaceType;
  /** The data provider for this virtual race. */
  readonly source: Scalars['String'];
  /** The race's unique identifier from the data provider's system. */
  readonly sourceRaceId: Scalars['String'];
  /** The scheduled start time of the virtual race. */
  readonly startTime: Scalars['TimeStamp'];
  /** The timestamp of the last update to the virtual race's information. */
  readonly updated: Scalars['TimeStamp'];
};

/** Contains the complete results for a finished virtual race, including finishing positions and dividends. */
export type VirtualRaceResult = {
  readonly __typename?: 'VirtualRaceResult';
  /** A list of all payout dividends for various bet types. */
  readonly dividend: ReadonlyArray<VirtualResultDividend>;
  /** A list of the official finishing positions for each competitor. */
  readonly position: ReadonlyArray<VirtualResultPosition>;
  /** The unique identifier of the virtual race. */
  readonly raceId: Scalars['ID'];
};

export enum VirtualRaceStatus {
  BettingSuspended = 'BETTING_SUSPENDED',
  Cancelled = 'CANCELLED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  OpenForBetting = 'OPEN_FOR_BETTING',
  PartialResult = 'PARTIAL_RESULT',
  Pending = 'PENDING'
}

/** A real-time update payload for changes to a virtual race's status. */
export type VirtualRaceStatusUpdate = {
  readonly __typename?: 'VirtualRaceStatusUpdate';
  /** The unique identifier of the virtual race being updated. */
  readonly raceId: Scalars['ID'];
  /** The new status of the virtual race. */
  readonly raceStatus: VirtualRaceStatus;
};

export enum VirtualRaceType {
  DashingDerby = 'DASHING_DERBY',
  HarnessRacing = 'HARNESS_RACING',
  PlatinumHounds = 'PLATINUM_HOUNDS',
  SteepleChase = 'STEEPLE_CHASE'
}

/** Represents a single dividend payout for a winning bet type in a virtual race. */
export type VirtualResultDividend = {
  readonly __typename?: 'VirtualResultDividend';
  /** The bet type this dividend applies to (e.g., WIN, TRIFECTA). */
  readonly betType: VirtualBetType;
  /** The timestamp when this dividend was created. */
  readonly created: Scalars['TimeStamp'];
  /** The payout amount for a standard betting unit. */
  readonly dividend: Scalars['Float'];
  /** The timestamp of the last update to this dividend. */
  readonly updated: Scalars['TimeStamp'];
  /** A string representing the winning combination of runner numbers. */
  readonly winSelectionString: Scalars['String'];
};

/** Describes the finishing position of a single competitor in a virtual race. */
export type VirtualResultPosition = {
  readonly __typename?: 'VirtualResultPosition';
  /** The unique internal identifier of the competitor. */
  readonly competitorId: Scalars['ID'];
  /** The timestamp when this result was created. */
  readonly created: Scalars['TimeStamp'];
  /** The official finishing place (e.g., 1 for 1st, 2 for 2nd). */
  readonly position: Scalars['Int'];
  /** The name of the competitor. */
  readonly runnerName: Scalars['String'];
  /** The runner number of the competitor. */
  readonly runnerNumber: Scalars['Int'];
  /** The competitor's unique identifier from the data provider's system. */
  readonly sourceCompetitorId: Scalars['String'];
  /** The timestamp of the last update to this result. */
  readonly updated: Scalars['TimeStamp'];
};

/** Represents a single betting selection and its associated odds. */
export type VirtualSelectionEntry = {
  readonly __typename?: 'VirtualSelectionEntry';
  /** The timestamp when this selection was created. */
  readonly created: Scalars['TimeStamp'];
  /** The decimal odds for this selection. */
  readonly odds: Scalars['Float'];
  /** A string identifying the selection. */
  readonly selectionString: Scalars['String'];
  /** The timestamp of the last update to this selection's odds. */
  readonly updated: Scalars['TimeStamp'];
};

/** A container for all available betting markets and selections for a virtual race. */
export type VirtualSelections = {
  readonly __typename?: 'VirtualSelections';
  /** A list of available selections, grouped by the bet type. */
  readonly betTypes: ReadonlyArray<VirtualBetTypeGroup>;
  /** The unique identifier of the virtual race these selections belong to. */
  readonly race_id: Scalars['ID'];
};

export type InputSourceId = {
  readonly source: Scalars['String'];
  readonly sourceId: Scalars['String'];
};

export type InputSourceRaceId = {
  readonly number?: InputMaybe<Scalars['Int']>;
  readonly source: Scalars['String'];
  readonly sourceId: Scalars['String'];
};

export type InputSourceType = {
  readonly source: Scalars['String'];
  readonly type: PriceType;
};

export type MeetingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type MeetingQuery = { readonly __typename?: 'Query', readonly meeting?: { readonly __typename?: 'Meeting', readonly id: string, readonly type: MeetingType, readonly races: ReadonlyArray<{ readonly __typename?: 'Race', readonly id: string, readonly number: number, readonly status: RaceStatus, readonly startTime: string }>, readonly track: { readonly __typename?: 'Track', readonly id: string, readonly name: string, readonly surface: string, readonly country: string } } | null };

export type MeetingsDatedQueryVariables = Exact<{
  firstRaceFrom?: InputMaybe<Scalars['Time']>;
  to?: InputMaybe<Scalars['Time']>;
}>;


export type MeetingsDatedQuery = { readonly __typename?: 'Query', readonly meetingsDated: ReadonlyArray<{ readonly __typename?: 'Meeting', readonly id: string, readonly type: MeetingType, readonly track: { readonly __typename?: 'Track', readonly id: string, readonly name: string, readonly surface: string, readonly country: string }, readonly races: ReadonlyArray<{ readonly __typename?: 'Race', readonly id: string, readonly number: number, readonly status: RaceStatus, readonly startTime: string, readonly meeting: { readonly __typename?: 'Meeting', readonly id: string } }> }> };

export type RaceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  silksSize: Scalars['Int'];
}>;


export type RaceQuery = { readonly __typename?: 'Query', readonly race?: { readonly __typename?: 'Race', readonly id: string, readonly number: number, readonly name: string, readonly distance: number, readonly startTime: string, readonly class: string, readonly status: RaceStatus, readonly prizeMoney: number, readonly trackCondition: TrackCondition, readonly weather: string, readonly surfaceType: string, readonly meeting: { readonly __typename?: 'Meeting', readonly id: string, readonly type: MeetingType, readonly externalIDs?: ReadonlyArray<{ readonly __typename?: 'SourceId', readonly id: string, readonly source: string } | null> | null, readonly track: { readonly __typename?: 'Track', readonly id: string, readonly country: string, readonly name: string, readonly state: string } }, readonly priceSets: ReadonlyArray<{ readonly __typename?: 'PriceSet', readonly source: string, readonly raceNumber: number, readonly type: PriceType, readonly poolSize: number, readonly prices: ReadonlyArray<{ readonly __typename?: 'Price', readonly source: string, readonly tabNo: number, readonly price: number, readonly type: PriceType }> }>, readonly results: ReadonlyArray<{ readonly __typename?: 'ResultSet', readonly source: string, readonly positions: ReadonlyArray<{ readonly __typename?: 'ResultPosition', readonly tabNo: number, readonly position: number, readonly margin?: number | null }>, readonly dividends: ReadonlyArray<{ readonly __typename?: 'ResultDividend', readonly dividendNumbers: ReadonlyArray<number>, readonly dividend: number, readonly type: BetType, readonly poolSize: number }> }>, readonly competitors: ReadonlyArray<{ readonly __typename?: 'Competitor', readonly tabNo: number, readonly barrier: number, readonly name: string, readonly scratched: boolean, readonly silksURL: string, readonly prices: ReadonlyArray<{ readonly __typename?: 'Price', readonly price: number, readonly type: PriceType, readonly tabNo: number, readonly source: string }>, readonly flucs: ReadonlyArray<{ readonly __typename?: 'PriceFluc', readonly price: number, readonly time: string }> }> } | null };

export type RaceUpdatedSubscriptionVariables = Exact<{
  raceId?: InputMaybe<Scalars['ID']>;
}>;


export type RaceUpdatedSubscription = { readonly __typename?: 'Subscription', readonly raceUpdated: { readonly __typename?: 'RaceUpdate', readonly id: string, readonly startTime: string, readonly status: RaceStatus, readonly surfaceType: string, readonly competitors: ReadonlyArray<{ readonly __typename?: 'CompetitorUpdate', readonly scratched: boolean, readonly tabNo: number }> } };

export type PriceUpdatesSubscriptionVariables = Exact<{
  raceId?: InputMaybe<Scalars['ID']>;
}>;


export type PriceUpdatesSubscription = { readonly __typename?: 'Subscription', readonly priceUpdates: { readonly __typename?: 'PriceSet', readonly source: string, readonly raceNumber: number, readonly type: PriceType, readonly poolSize: number, readonly prices: ReadonlyArray<{ readonly __typename?: 'Price', readonly source: string, readonly tabNo: number, readonly price: number, readonly type: PriceType }> } };

export type ResultsSubscriptionVariables = Exact<{
  raceId?: InputMaybe<Scalars['ID']>;
}>;


export type ResultsSubscription = { readonly __typename?: 'Subscription', readonly results: { readonly __typename?: 'ResultSet', readonly source: string, readonly raceId: string, readonly status: ResultStatus, readonly positions: ReadonlyArray<{ readonly __typename?: 'ResultPosition', readonly tabNo: number, readonly position: number, readonly margin?: number | null }>, readonly dividends: ReadonlyArray<{ readonly __typename?: 'ResultDividend', readonly dividendNumbers: ReadonlyArray<number>, readonly dividend: number, readonly type: BetType, readonly poolSize: number }> } };


export const MeetingDocument = gql`
    query meeting($id: ID) {
  meeting(id: $id) {
    id
    type
    races {
      id
      number
      status
      startTime
    }
    track {
      id
      name
      surface
      country
    }
  }
}
    `;

/**
 * __useMeetingQuery__
 *
 * To run a query within a React component, call `useMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMeetingQuery(baseOptions?: Apollo.QueryHookOptions<MeetingQuery, MeetingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingQuery, MeetingQueryVariables>(MeetingDocument, options);
      }
export function useMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingQuery, MeetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingQuery, MeetingQueryVariables>(MeetingDocument, options);
        }
export type MeetingQueryHookResult = ReturnType<typeof useMeetingQuery>;
export type MeetingLazyQueryHookResult = ReturnType<typeof useMeetingLazyQuery>;
export type MeetingQueryResult = Apollo.QueryResult<MeetingQuery, MeetingQueryVariables>;
export const MeetingsDatedDocument = gql`
    query meetingsDated($firstRaceFrom: Time, $to: Time) {
  meetingsDated(firstRaceFrom: $firstRaceFrom, to: $to) {
    id
    track {
      id
      name
      surface
      country
    }
    races {
      id
      number
      status
      startTime
      meeting {
        id
      }
    }
    type
  }
}
    `;

/**
 * __useMeetingsDatedQuery__
 *
 * To run a query within a React component, call `useMeetingsDatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingsDatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingsDatedQuery({
 *   variables: {
 *      firstRaceFrom: // value for 'firstRaceFrom'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMeetingsDatedQuery(baseOptions?: Apollo.QueryHookOptions<MeetingsDatedQuery, MeetingsDatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingsDatedQuery, MeetingsDatedQueryVariables>(MeetingsDatedDocument, options);
      }
export function useMeetingsDatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingsDatedQuery, MeetingsDatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingsDatedQuery, MeetingsDatedQueryVariables>(MeetingsDatedDocument, options);
        }
export type MeetingsDatedQueryHookResult = ReturnType<typeof useMeetingsDatedQuery>;
export type MeetingsDatedLazyQueryHookResult = ReturnType<typeof useMeetingsDatedLazyQuery>;
export type MeetingsDatedQueryResult = Apollo.QueryResult<MeetingsDatedQuery, MeetingsDatedQueryVariables>;
export const RaceDocument = gql`
    query race($id: ID, $silksSize: Int!) {
  race(id: $id) {
    id
    number
    name
    distance
    startTime
    class
    status
    prizeMoney
    trackCondition
    weather
    surfaceType
    meeting {
      id
      type
      externalIDs(sources: ["gbs"]) {
        id
        source
      }
      track {
        id
        country
        name
        state
      }
    }
    priceSets(sources: []) {
      source
      raceNumber
      type
      poolSize
      prices {
        source
        tabNo
        price
        type
      }
    }
    results(sources: []) {
      source
      positions {
        tabNo
        position
        margin
      }
      dividends {
        dividendNumbers
        dividend
        type
        poolSize
      }
    }
    competitors {
      tabNo
      barrier
      name
      scratched
      silksURL(size: $silksSize)
      prices(sources: []) {
        price
        type
        tabNo
        source
      }
      flucs(source: "OP", priceType: WIN_FIXED_ODDS) {
        price
        time
      }
    }
  }
}
    `;

/**
 * __useRaceQuery__
 *
 * To run a query within a React component, call `useRaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      silksSize: // value for 'silksSize'
 *   },
 * });
 */
export function useRaceQuery(baseOptions: Apollo.QueryHookOptions<RaceQuery, RaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RaceQuery, RaceQueryVariables>(RaceDocument, options);
      }
export function useRaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RaceQuery, RaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RaceQuery, RaceQueryVariables>(RaceDocument, options);
        }
export type RaceQueryHookResult = ReturnType<typeof useRaceQuery>;
export type RaceLazyQueryHookResult = ReturnType<typeof useRaceLazyQuery>;
export type RaceQueryResult = Apollo.QueryResult<RaceQuery, RaceQueryVariables>;
export const RaceUpdatedDocument = gql`
    subscription raceUpdated($raceId: ID) {
  raceUpdated(raceId: $raceId) {
    id
    startTime
    status
    competitors {
      scratched
      tabNo
    }
    surfaceType
  }
}
    `;

/**
 * __useRaceUpdatedSubscription__
 *
 * To run a query within a React component, call `useRaceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRaceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRaceUpdatedSubscription({
 *   variables: {
 *      raceId: // value for 'raceId'
 *   },
 * });
 */
export function useRaceUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RaceUpdatedSubscription, RaceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RaceUpdatedSubscription, RaceUpdatedSubscriptionVariables>(RaceUpdatedDocument, options);
      }
export type RaceUpdatedSubscriptionHookResult = ReturnType<typeof useRaceUpdatedSubscription>;
export type RaceUpdatedSubscriptionResult = Apollo.SubscriptionResult<RaceUpdatedSubscription>;
export const PriceUpdatesDocument = gql`
    subscription priceUpdates($raceId: ID) {
  priceUpdates(raceId: $raceId) {
    source
    raceNumber
    type
    poolSize
    prices {
      source
      tabNo
      price
      type
    }
  }
}
    `;

/**
 * __usePriceUpdatesSubscription__
 *
 * To run a query within a React component, call `usePriceUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePriceUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceUpdatesSubscription({
 *   variables: {
 *      raceId: // value for 'raceId'
 *   },
 * });
 */
export function usePriceUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PriceUpdatesSubscription, PriceUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PriceUpdatesSubscription, PriceUpdatesSubscriptionVariables>(PriceUpdatesDocument, options);
      }
export type PriceUpdatesSubscriptionHookResult = ReturnType<typeof usePriceUpdatesSubscription>;
export type PriceUpdatesSubscriptionResult = Apollo.SubscriptionResult<PriceUpdatesSubscription>;
export const ResultsDocument = gql`
    subscription results($raceId: ID) {
  results(raceId: $raceId) {
    source
    raceId
    status
    positions {
      tabNo
      position
      margin
    }
    dividends {
      dividendNumbers
      dividend
      type
      poolSize
    }
  }
}
    `;

/**
 * __useResultsSubscription__
 *
 * To run a query within a React component, call `useResultsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResultsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultsSubscription({
 *   variables: {
 *      raceId: // value for 'raceId'
 *   },
 * });
 */
export function useResultsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ResultsSubscription, ResultsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResultsSubscription, ResultsSubscriptionVariables>(ResultsDocument, options);
      }
export type ResultsSubscriptionHookResult = ReturnType<typeof useResultsSubscription>;
export type ResultsSubscriptionResult = Apollo.SubscriptionResult<ResultsSubscription>;